import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { FaPlus, FaRegTrashAlt, FaEye, FaCheck, FaEdit, FaTrash, FaInfo, FaFileDownload } from 'react-icons/fa';
import { getData, postData, urlApiProduccion } from '../../api/ApiRest';
import LoadingComponent from './../../widgets/LoadingComponent';
import { updateEmpresaLogo } from './../empresa/EmpresaApi'
import Resoluciones from './Resoluciones';
import Planes from './Planes';
import { NumericFormat } from 'react-number-format';
import {
    Box, Paper, Grid, TextField, MenuItem, Button, Typography, Breadcrumbs,
    Chip, Tooltip, IconButton, Checkbox, FormControlLabel,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import { MdClose } from 'react-icons/md';
import { styled } from '@mui/material/styles';
import Swal from 'sweetalert2';
import { getSoftwareConfigItem, updateActiveCompany } from '../../components/services/companyAPI';
import EmpresaCertificadoCrud from '../empresa/EmpresaCertificadoCrud';
import EmpresaSoftwareCrud from '../empresa/EmpresaSoftwareCrud';
import EmpresaNominaSoftwareCrud from '../empresa/EmpresaNominaSoftwareCrud'
import EmpresaPOSSoftware from '../empresa/EmpresaPOSSoftware';
import { FaDownload } from 'react-icons/fa6';
import { exportToExcel } from 'react-json-to-excel';
import moment from 'moment';
import { FaDownLong, FaXmark } from 'react-icons/fa6';
import auditoriaSet from '../../widgets/Auditoria';
import { usePermission } from '../../helper/authHelper';
import { useSelector } from 'react-redux';
import EmpresaDSoporteSoftware from '../empresa/EmpresaDSoporteSoftware';
import { formatDateddMMyyyyhhmm } from '../../widgets/DateTime';
import ImapConfigurationModal from '../../widgets/ImapConfigurationModal';
import { PDFDownloadLink } from '@react-pdf/renderer';
import TaePdfDocumento from '../reporte/TaePdfDocumento';

// ── Estilos de tabla ──────────────────────────────────────────────────────────

const HeaderCell = styled(TableCell)(() => ({
    backgroundColor: '#224B6A',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '0.78rem',
    whiteSpace: 'nowrap',
    padding: '10px 12px',
}));

const BodyCell = styled(TableCell)(() => ({
    fontSize: '0.78rem',
    padding: '7px 12px',
    borderColor: '#dee2e6',
}));

const StyledRow = styled(TableRow)(({ index }) => ({
    backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc',
    '&:hover': { backgroundColor: 'rgba(144, 203, 216, 0.2)' },
}));

const inputSx = {
    '& .MuiInputBase-input': { fontSize: '0.82rem' },
    '& .MuiInputLabel-root': { fontSize: '0.82rem' },
};

function EmpresaConfig() {
    const [loading, setLoading] = useState(false);
    const [typesDocumentIdentifications, setTypesDocumentIdentifications] = useState([]);
    const [typeOrganizations, setTypeOrganizations] = useState([]);
    const [typeRegimens, setTypeRegimens] = useState([]);
    const [typeLiabilites, setTypeLiabilites] = useState([]);
    const [departamentsCities, setDepartamentsCities] = useState([]);
    const [departmentid, setDepartmentid] = useState('');
    const [Cities, setCities] = useState([]);
    const [logoBase64, setLogoBase64] = useState('');
    const [companyToken, setCompanyToken] = useState('');
    const [logoUrl, setLogoUrl] = useState('');
    const [htmlFactura, setHtmlFactura] = useState({ header: '', body: '', footer: '', templateFacturaPos: '' })
    const [facturacionAmbiente, setFacturacionAmbiente] = useState('');
    const [nominaAmbiente, setNominaAmbiente] = useState('');
    const [docEquivAmbiente, setDocEquivAmbiente] = useState('');
    const [docSoporte, setDocSoporte] = useState('');
    const [eventoRadian, setEventoRadian] = useState('');
    const [sucursales, SetSucursales] = useState([]);
    const [sucursalData, SetSucursalData] = useState({
        Nuevo: false,
        Codigo: '',
        Nombre: '',
        Direccion: '',
        Telefono: '',
        Email: '',
        Departamentoid: '',
        Ciudadid: ''
    });
    const [sucursalEditOpen, setSucursalEditOpen] = useState(false);
    const [sucursalEditData, setSucursalEditData] = useState({
        Id: '',
        Codigo: '',
        Nombre: '',
        Direccion: '',
        Telefono: '',
        Email: '',
        Departamentoid: '',
        Ciudadid: ''
    });
    const [documentosLegal, setDocumentosLegal] = useState({
        adjuntos: [],
        camaraComerciao_Detalle: null,
        camaraComercio: false,
        cedulaRepLegal: false,
        cedulaRepLegal_Detalle: null,
        rut: false,
        rut_Detalle: null
    });
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioNuevo, setUsuarioNuevo] = useState({ Nuevo: false, Correo: '', Contrasena: '', ModalVisible: false, Usuarioid: '', Rollid: '', Activo: false });
    const [planesDispibles, setPlanesDisponibles] = useState([]);
    const [planesActuales, setPlanesActuales] = useState([]);
    const [planSugeridoSeleccionado, setPlanSugeridoSeleccionado] = useState(null);
    const [buscarEmisionesInstancia, setBuscarEmisionesInstancia] = useState({ MMM: new Date().getMonth() + 1, YYYY: new Date().getFullYear() });
    const [emisionesInstancia, setEmisionesInstancia] = useState([]);
    const [emisionesMes, setEmisionesMes] = useState([]);
    const [emisionesMesExcel, setEmisionesMesExcel] = useState([]);
    const [totalEmisionesMes, setTotalEmisionesMes] = useState(0);

    const [idenfication, setIdentification] = useState({ Nit: '', Dv: '' });
    const [nombreAlterno, setNombreAlterno] = useState('');
    const [isActiveCompany, setIsActiveCompany] = useState(false);
    const [softwareValues, setSoftwareValues] = useState({});
    const [notasCompany, setNotasCompany] = useState([]);
    const [notaCompanyCrud, setNotaCompanyCrud] = useState({ ModalVisible: false, Categoria: '', Nota: '' });
    const [rolCompanyCrud, setRolCompanyCrud] = useState({ ModalVisible: false, Descripcion: '', Activo: true, Titulo: '', Rollid: '' });

    const [rollPermiso, setRollPermiso] = useState([]);
    const [permisoAnterior, setPermisoAnterior] = useState(null);
    const [historialPermiso, setHistorialPermiso] = useState([]);
    const [rollPermisoGlobal, setPermisoGlobal] = useState([]);
    const [rollAsignaUsuario, setRollAsignaUsuario] = useState([]);

    const [infoContactos, setInfoContactos] = useState({
        nombrecompleto: '', telefono: '', correo: '', cargo: '', nuevo: false
    });

    const [configRadian, setConfigRadian] = useState({
        nuevo: false,
        id: '',
        correo: '',
        clave: '',
        proveedor: '',
        estado: false,
        imapHost: '',
        imapPort: '',
        ssl_aplica: false,
        fechaUltSincro: '',
        correoNuevo: '',
        buzonCompartido: ''
    });

    const [configRadianOld, setConfigRadianOld] = useState({
        nuevo: false,
        id: '',
        correo: '',
        clave: '',
        proveedor: '',
        estado: false,
        imapHost: '',
        imapPort: '',
        ssl_aplica: false,
        fechaUltSincro: '',
        correoNuevo: '',
        buzonCompartido: ''
    });

    const [configuracionRadian, setConfiguracionRadian] = useState([]);
    const [contactos, setContactos] = useState([]);

    const [mostrarImap, setMostrarImap] = useState(false);

    const [usuarioAnterior, setUsuarioAnterior] = useState([]);

    const [datosNuevoEmpresa, setDatosNuevoEmpresa] = useState({
        type_document_identification_id: 3,
        type_organization_id: 2,
        type_regime_id: 2,
        type_liability_id: 14,
        business_name: '',
        merchant_registration: '0000000-00',
        municipality_id: 820,
        address: '',
        phone: 0,
        email: '',
        mail_host: 'xx.gmail.com',
        mail_port: 587,
        mail_username: '',
        mail_password: '',
        mail_encryption: 'tls'
    })

    const [datosEmpresa, setDatosEmpresa] = useState({
        type_document_identification_id: 3,
        type_organization_id: 2,
        type_regime_id: 2,
        type_liability_id: 14,
        business_name: '',
        merchant_registration: '0000000-00',
        municipality_id: 820,
        address: '',
        phone: 0,
        email: '',
        mail_host: 'xx.gmail.com',
        mail_port: 587,
        mail_username: '',
        mail_password: '',
        mail_encryption: 'tls'
    })

    const descargarExcel = () => {
        const value = emisionesMesExcel;
        if (value.length === 0) {
            alert("No hay datos para descargar");
            return;
        }

        exportToExcel(value, "EmisionesMesDias");
    };

    const infoUser = useSelector((state) => state.auth);
    const CompanyId = useParams().CompanyId;

    const navigate = useNavigate();

    const getSoftwareConfigFunc = async (nit) => {
        if (!nit) return console.error("No se envió NIT");

        const result = await getSoftwareConfigItem(nit)
        setSoftwareValues(result);
        setCompanySelect(result);
    }

    ///Establecemos todos los permisos de manera global, para que carguen cada vez que se haga render en la pagina, se realiza de esta
    ///manera por lo que se utiliza hooks personalizados y se debe establecer de manera global, mas no dentro de propiedades como if, map, etc
    const { GestionUsuario, GestionSucursal, EditEmpresa, EliminResolu, EstadoCompany, GestionAmbiente,
        GestionCorreos, GestionPlan, GestionSoftware, GestionDocumentos, VisualizarEmpresa, VisualizarDocumentos, VisualizarUsuarios,
        VisualizarSucursales, VisualizarResoluc, VisualizarAmbientes, VisualizaPlanes, VisualizaLogo, GestionLogo, GestionRolCompa,
        GestionResoluc, GestionContactos, VisualizarContactos, EliminarContactos, GestionConfigRadian
    } = usePermission([
        "GestionUsuario",
        "GestionSucursal",
        "EditEmpresa",
        "EliminResolu",
        "EstadoCompany",
        "GestionAmbiente",
        "GestionCorreos",
        "GestionPlan",
        "GestionSoftware",
        "GestionDocumentos",
        "VisualizarEmpresa",
        "VisualizarDocumentos",
        "VisualizarUsuarios",
        "VisualizarSucursales",
        "VisualizarResoluc",
        "VisualizarAmbientes",
        "VisualizaPlanes",
        "VisualizaLogo",
        "GestionLogo",
        "GestionRolCompa",
        "GestionResoluc",
        "GestionContactos",
        "VisualizarContactos",
        "EliminarContactos",
        "GestionConfigRadian"
    ]);

    useEffect(() => {
        setLoading(true);
        setLogoUrl(infoUser.AmbienteApiDian_Url);
        //setLogoUrl(localStorage.getItem('AmbienteApiDian_Url'));

        // func qué obtiene detalle de empresa
        getData('api/Configuracion/Company/CreateGetInfo', { id: CompanyId }, false).then(response => {
            if (response.status === true) {
                setIsActiveCompany(response?.model?.active_company);
                setNombreAlterno(response.nombreAlterno);
                setTypesDocumentIdentifications(response.typesDocumentIdentifications);
                setTypeOrganizations(response.typesOrganizations);
                setTypeRegimens(response.typesRegimens);
                setTypeLiabilites(response.typesLiabilites);
                setDepartamentsCities(response.departamentsCities);
                setCities(response.cities);
                setDatosNuevoEmpresa(response.model);
                setDatosEmpresa(response.model);
                setIdentification({ Nit: response.identification.nit, Dv: response.identification.dv });
                setDepartmentid(response.municipalityId);
                setCompanyToken(response.companyToken);
                setFacturacionAmbiente(response.facturacion_Ambiente);
                setNominaAmbiente(response.nomina_Ambiente);
                setDocEquivAmbiente(response.docEquiv_Ambiente);
                setDocSoporte(response.docSoporte);
                setEventoRadian(response.eventType);

                getSoftwareConfigFunc(response.identification.nit);
            } else {
                navigate('/Home/Empresa/Config/' + infoUser.CompanyId);
            }

            setLoading(false);

        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal al cargar el formulario');
        })

        verPermisosGlobales();

        if (usuarioNuevo.Usuarioid) {
            verPermisosUsuarios(usuarioNuevo.Usuarioid); ///Para cargar los roles previamente asignados
        }

        convertirBase64();

    }, [CompanyId, usuarioNuevo.Usuarioid])

    // Configuración Certificados
    const [certificateModal, setCertificateModal] = useState(false);
    const [companySelect, setCompanySelect] = useState({});
    const [nominaSoftwareModal, setNominaSoftwareModal] = useState(false);
    const [posSoftwareModal, setPOSSoftwareModal] = useState(false);
    const [documentoSoporteSoftwareModal, setDocumentoSoporteSoftwareModal] = useState(false);

    const [modalConfigRadian, setModalConfigRadian] = useState({
        ModalVisible: false, Titulo: ''
    });

    const [infoPlanCompany, setInfoCompanyPlan] = useState(null);

    // Configuración FE
    const [softwareModal, setSoftwareModal] = useState(false)

    // Btn Func Certificates
    const certificateModalAbrir = () => {
        setCertificateModal(true);
        setCompanySelect(companySelect);
    }

    // Btn Func FE
    const softwareModalAbrir = () => {
        setSoftwareModal(true);
        setCompanySelect(companySelect);
    }

    // Btn func Nomina
    const nominaSoftwareModalAbrir = () => {
        setNominaSoftwareModal(true);
        setCompanySelect(companySelect);
    }

    // Btn func P.O.S
    const posSoftwareModalAbrir = () => {
        setPOSSoftwareModal(true);
        setCompanySelect(companySelect);
    }

    const DocumentoSoporteSoftwareModalAbrir = () => {
        setDocumentoSoporteSoftwareModal(true);
        setCompanySelect(companySelect);
    }

    const certificateButton = () => {
        //certificates
        if (softwareValues.certificates === 0) {
            return <Button type='button' size='sm' variant='warning' title='Agregar Certificado'
                onClick={() => certificateModalAbrir()} style={{ margin: '1rem' }}>
                <FaPlus size={'1rem'} />
            </Button>
        } else {
            return <Button type='button' size='sm' variant='secondary' title='Ver configuracion de Certificado test'
                onClick={() => certificateModalAbrir()} style={{ margin: '1rem' }}>
                <FaEye size={'1rem'} />
            </Button>
        }
    }

    // F.E
    const softwareButton = () => {
        return <Button type='button' size='sm' variant='secondary' title='Ver configuracion de software two'
            onClick={() => softwareModalAbrir()} style={{ margin: "1rem" }}>
            <FaEye size={'1rem'} />
        </Button>

    }

    //Nomina
    const nominaSoftwareButton = () => {
        return <Button type='button' size='sm' variant='secondary' title='Ver configuracion de software de nomina'
            onClick={() => nominaSoftwareModalAbrir()} style={{ margin: "1rem" }}>
            <FaEye size={'1rem'} />
        </Button>
    }

    //P.O.S
    const posSoftwareButton = () => {
        return <Button type='button' size='sm' variant='secondary' title='Ver configuracion de software POS'
            onClick={() => posSoftwareModalAbrir()} style={{ margin: "1rem" }}>
            <FaEye size={'1rem'} />
        </Button>
    }

    //Documento soporte
    const DocumentoSoporteSoftwareButton = () => {
        return <Button type='button' size='sm' variant='secondary' title='Ver configuracion de software documento soporte'
            onClick={() => DocumentoSoporteSoftwareModalAbrir()} style={{ margin: "1rem" }}>
            <FaEye size={'1rem'} />
        </Button>
    }

    const citiesLoad = (Departmanentid) => {
        setLoading(true);

        getData('api/Configuracion/Company/CitiesGet', { Departamentid: Departmanentid },
            false).then(response => {

                setCities(response.cities);

                setLoading(false);

            }, error => {
                console.log(error);
                setLoading(false);
                alert('Algo salio mal al cargar el formulario');
            })

    }


    const guardar = (event) => {
        setLoading(true);
        event.preventDefault();

        if (!EditEmpresa) {
            alert("No tienes permiso para modificar la empresa");
            setLoading(false);
            return;
        }

        postData('api/Configuracion/Company/CreateOrUpdateCompany', {
            Nit: idenfication.Nit,
            Dv: idenfication.Dv,
            Nuevo: false,
            NombreAlterno: nombreAlterno,
        }, datosNuevoEmpresa, false).then(response => {
            alert('Actualizacion exitosa');

            ///Función para guardar la auditoria cuando se guarda un cambio de la empresa
            auditoriaSet(datosEmpresa, datosNuevoEmpresa, 'A', 'Empresa', CompanyId, 'General');

            console.log(response);
            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor verifica la informacion');
        })

    }


    const procesarLogo = (e) => {
        setLoading(true);
        const Archivo = e.target.files[0];

        let reader = new FileReader();
        reader.readAsDataURL(Archivo);
        reader.onload = function () {
            setLogoBase64(reader.result.replace(/^data:image\/[a-z]+;base64,/, ""));
            setLoading(false);
            console.log(reader);
        };
    }

    const cargarLogo = () => {
        if (logoBase64 === '' || logoBase64 === null) {
            alert('Por favor selecciona primero un logo');
            return;
        }

        if (loading === true) {
            alert('Espera un momento mientras termina la peticion anterior');
            return;
        }

        setLoading(true);

        updateEmpresaLogo({ logo: logoBase64 }, companyToken).then(response => {
            console.log(response);

            ///Función para cargar el logo de una compañía
            auditoriaSet({
                Tipo: 'Carga logo'
            }, {}, 'C', 'Empresa', CompanyId, 'Logo');

            setLoading(false);
        }, error => {
            console.log(error);
        })
    }


    const getLogo = () => {
        let UrlBase = logoUrl;
        UrlBase = UrlBase.replace('api/ubl2.1', '');
        UrlBase = UrlBase + '/storage/' + idenfication.Nit + '/' + idenfication.Nit + idenfication.Dv + '.jpg';

        return <img src={UrlBase} style={{ maxWidth: '300px' }} alt='Logo imagen'></img>;
    }


    const facturaHtmlCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/FacturaHtmlConfig', { Companyid: CompanyId }, false).then(response => {
            // console.log(response);
            if (response.status === true) {
                setHtmlFactura({
                    header: response.model.header,
                    body: response.model.body,
                    footer: response.model.footer,
                    templateFacturaPos: response.model.templatePos || ''
                })
            }
            else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal en el cargue inicial')
        })
    }


    const facturaHtmlUpdate = () => {
        setLoading(true);

        if (!GestionCorreos) {
            alert('No tienes permiso para actualizar el cuerpo de correos');
            setLoading(false);
            return;
        }

        postData('api/Configuracion/Company/FacturaHtmlUpdate', { Companyid: CompanyId }, {
            Footer: htmlFactura.footer,
            Body: htmlFactura.body,
            Header: htmlFactura.header,
            TemplatePos: htmlFactura.templateFacturaPos
        }, false).then(response => {
            // console.log(response);
            if (response.status === true) {
                alert('Actualizacion exitosa');

                ///Función para guardar la auditoría
                auditoriaSet(htmlFactura, {}, 'C', 'Empresa', CompanyId, 'FormatoCorreo');
            }
            else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal en el cargue inicial')
        })
    }


    const facturaCambiaAmbiente = (NuevoAmbiente = '') => {
        if (!GestionAmbiente) {
            alert('No tienes permiso para gestionar los ambientes');
            return;
        }

        getData('api/Configuracion/Company/EnviromentChange', {
            CompanyId: CompanyId,
            Factura: NuevoAmbiente,
            Nomina: nominaAmbiente,
            DocEquiv: docEquivAmbiente,
            SupportDocument: docSoporte,
            EventType: eventoRadian
        }).then(response => {
            setLoading(false);
            window.location.reload();
            console.log(response);
        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })

        ///Función para guardar auditoría
        auditoriaSet({
            Factura: NuevoAmbiente === "2" ? "Producción" : "Pruebas"
        }, { Factura: facturacionAmbiente === "2" ? "Producción" : "Pruebas" }, 'A', 'Empresa', CompanyId, 'Ambiente');
    }

    const nominaCambiaAmbiente = (NuevoAmbiente = '') => {
        if (!GestionAmbiente) {
            alert('No tienes permiso para gestionar los ambientes');
            return;
        }

        getData('api/Configuracion/Company/EnviromentChange', {
            CompanyId: CompanyId,
            Factura: facturacionAmbiente,
            Nomina: NuevoAmbiente,
            DocEquiv: docEquivAmbiente,
            SupportDocument: docSoporte,
            EventType: eventoRadian
        }).then(response => {
            setLoading(false);
            window.location.reload();
            console.log(response);
        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })

        ///Función para guardar auditoría
        auditoriaSet({
            Nomina: NuevoAmbiente === "2" ? "Producción" : "Pruebas"
        }, { Nomina: nominaAmbiente === "2" ? "Producción" : "Pruebas" }, 'A', 'Empresa', CompanyId, 'Ambiente');
    }

    const docEquivCambiaAmbiente = (NuevoAmbiente = '') => {
        if (!GestionAmbiente) {
            alert('No tienes permiso para gestionar los ambientes');
            return;
        }

        getData('api/Configuracion/Company/EnviromentChange', {
            CompanyId: CompanyId,
            Factura: facturacionAmbiente,
            Nomina: nominaAmbiente,
            DocEquiv: NuevoAmbiente,
            SupportDocument: docSoporte,
            EventType: eventoRadian
        }).then(response => {
            setLoading(false);
            window.location.reload();
            console.log(response);
        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })

        ///Función para guardar auditoría
        auditoriaSet({
            DocEquiv: NuevoAmbiente === "2" ? "Producción" : "Pruebas"
        }, { DocEquiv: docEquivAmbiente === "2" ? "Producción" : "Pruebas" }, 'A', 'Empresa', CompanyId, 'Ambiente');
    }

    const docSoporteCambiaAmbiente = (NuevoAmbiente = '') => {
        if (!GestionAmbiente) {
            alert('No tienes permiso para gestionar los ambientes');
            return;
        }

        getData('api/Configuracion/Company/EnviromentChange', {
            CompanyId: CompanyId,
            Factura: facturacionAmbiente,
            Nomina: nominaAmbiente,
            DocEquiv: docEquivAmbiente,
            SupportDocument: NuevoAmbiente
        }).then(response => {
            setLoading(false);
            window.location.reload();
            console.log(response);
        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })

        ///Función para guardar auditoría
        auditoriaSet({
            SupportDocument: NuevoAmbiente === "2" ? "Producción" : "Pruebas"
        }, { SupportDocument: docSoporte === "2" ? "Producción" : "Pruebas" }, 'A', 'Empresa', CompanyId, 'Ambiente');
    }

    const EventoRadianCambiaAmbiente = (NuevoAmbiente = '') => {
        if (!GestionAmbiente) {
            alert('No tienes permiso para gestionar los ambientes');
            return;
        }

        getData('api/Configuracion/Company/EnviromentChange', {
            CompanyId: CompanyId,
            Factura: facturacionAmbiente,
            Nomina: nominaAmbiente,
            DocEquiv: docEquivAmbiente,
            SupportDocument: docSoporte,
            EventType: NuevoAmbiente
        }).then(response => {
            setLoading(false);
            window.location.reload();
            console.log(response);
        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })

        ///Función para guardar auditoría
        auditoriaSet({
            EventType: NuevoAmbiente === "2" ? "Producción" : "Pruebas"
        }, { EventType: eventoRadian === "2" ? "Producción" : "Pruebas" }, 'A', 'Empresa', CompanyId, 'Ambiente');
    }

    const sucursalesCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/SucursalesGet', { CompanyId: CompanyId }, false).then(response => {

            if (response.status === true) {
                SetSucursales(response.sucursales);
            }
            else {
                console.log(response);
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal en el cargue inicial')
        })
    }

    ///Función para agregarle un rol nuevo a un usuario
    const agregarRolUsuario = () => {
        setLoading(true);

        setRollAsignaUsuario([]);

        getData('api/Usuario/guardarRolUsuario', {
            Usuarioid: usuarioNuevo.Usuarioid,
            Rollid: usuarioNuevo.Rollid
        }, true).then(response => {
            setRollPermiso(prev => [
                ...prev,
                {
                    rollid: response.objectoRoll.rollid,
                    descripcion: response.objectoRoll.descripcion
                }
            ]);

            setRollAsignaUsuario(response.rolesMostrar);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
        })
    }

    ///Función para eliminar un rol especifico de un usuario
    const eliminarPermiso = (Rollid) => {
        setLoading(true);

        getData('api/Usuario/eliminarRolUsuario', {
            Rollid: Rollid,
            Usuarioid: usuarioNuevo.Usuarioid
        }, false).then(response => {
            if (response.status) {
                alert('Rol eliminado con éxito');
                setRollPermiso(prev => prev.filter(rol => rol.rollid !== Rollid));

                setRollAsignaUsuario(response.rolesMostrar);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const visualizarAutorizacionPlan = () => {
        setLoading(true);

        getData('api/Configuracion/Company/infoPlanCompany', {
            companyId: CompanyId
        }).then(response => {
            setInfoCompanyPlan(response.list);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const refrescarPropuesta = () => {
        if (!planSugeridoSeleccionado || !infoPlanCompany) return;
        const plan = planesDispibles.find(p => String(p.id) === String(planSugeridoSeleccionado));
        if (!plan) return;
        setInfoCompanyPlan({
            ...infoPlanCompany,
            nombrePlan: plan.nombre,
            foliosPlan: plan.cantidadAno,
            valorTotal: plan.valorAno,
        });
    }

    ///Función para visualizar los roles que han sido asignados a un usuario
    const verPermisosUsuarios = (item) => {
        getData('api/Usuario/getRollCreadosEmpresa', {
            compnayId: CompanyId,
            usuarioid: item
        }, false).then(response => {
            setRollPermiso(response.rolesTexto);

            const ids = response.rolesTexto.map(r => r.rollid);
            const disponibles = rollPermisoGlobal.filter(rolGlobal => !ids.includes(rolGlobal.rollid));

            setRollAsignaUsuario(disponibles);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
        })
    }

    ///Función para obtener la lista de contactos por empresa
    const contactoGetList = () => {
        setLoading(true);

        getData('api/Configuracion/Company/getListContactos', { company: CompanyId }).then(response => {
            setContactos(response.listContactos);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
        })
    }

    const radianConfigList = () => {
        setLoading(true);

        getData('api/Configuracion/Company/getConfigRadian', { companyId: CompanyId }).then(response => {
            setConfiguracionRadian(response.configRadian);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    ///Función para poder crear un contacto nuevo para una compañía
    const crearNuevoContacto = (event) => {
        event.preventDefault();
        setLoading(true);

        postData('api/Configuracion/Company/crearNuevoContacto', { CompanyId: CompanyId }, {
            Nombre: infoContactos.nombrecompleto,
            Cargo: infoContactos.cargo,
            Telefono: infoContactos.telefono,
            Correo: infoContactos.correo,
            companycontactoid: null
        }).then(response => {
            if (response.status) {
                contactoGetList();

                auditoriaSet(infoContactos, {}, 'C', 'Empresa', CompanyId, 'Contactos');

                setInfoContactos({
                    cargo: '',
                    nombrecompleto: '',
                    correo: '',
                    nuevo: false,
                    telefono: ''
                });
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
        })
    }

    ///Función para eliminar aquellos contactos que hayan registrado mal
    const eliminarContacto = (id, item) => {
        setLoading(true);

        let objecto = item;

        getData('api/Configuracion/Company/eliminarContacto', { id: id }).then(response => {
            if (response.status) {
                contactoGetList();

                auditoriaSet(objecto, {}, 'E', 'Empresa', CompanyId, 'Contactos');
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const sucursalCrearNueva = (event) => {
        event.preventDefault();
        setLoading(true);

        if (!GestionSucursal) {
            alert('No tienes permiso para realizar esta acción');
            setLoading(false);
            return;
        }

        if (sucursalData.Departamentoid === '' || sucursalData.Ciudadid === '') {
            alert('Por favor selecciona una sucursal');
            return;
        }

        postData('api/Configuracion/Company/SucursalCreate', { CompanyId: CompanyId }, {
            Id: null,
            CompanyId: CompanyId,
            Direccion: sucursalData.Direccion,
            Telefono: sucursalData.Telefono,
            Email: sucursalData.Email,
            NombreSucursal: sucursalData.Nombre,
            Codigo: sucursalData.Codigo,
            Municipality_Id: sucursalData.Ciudadid
        }).then(response => {

            if (response.status === true) {
                alert('Sucursal creada con exito');
                SetSucursalData({ ...sucursalData, Nuevo: false });

                ///Función para guardar la auditoría de sucursales
                auditoriaSet(sucursalData, {}, 'C', 'Empresa', CompanyId, 'Sucursales');

                sucursalesCargar();
            }
            else {
                alert(response.msj);
                console.log(response);
                setLoading(false);
            }


        }, error => {
            console.log(error);
            alert('Algo salio mal, por favor verifica');
            setLoading(false);
        })
    }

    const sucursalCargarDetalle = (sucursal) => {

        setLoading(true);

        getData('api/Configuracion/Company/SucursalEditGet', { CompanyId: CompanyId, Id: sucursal.id }, true).then(response => {
            console.log(response);
            if (response.status === true) {

                setSucursalEditData({
                    Id: sucursal.id,
                    Codigo: response.modelo.codigo,
                    Nombre: response.modelo.nombreSucursal,
                    Direccion: response.modelo.direccion,
                    Telefono: response.modelo.telefono,
                    Email: response.modelo.email,
                    Departamentoid: String(response.modelo.departamento_Id),
                    Ciudadid: String(response.modelo.municipality_Id)
                });

                setSucursalEditOpen(true);
            } else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            alert('Algo salio mal, por favor verifica');
            setLoading(false);
        });

    }

    const sucursalActualizar = (event) => {
        event.preventDefault();
        setLoading(true);

        if (!GestionSucursal) {
            alert('No tienes permiso para realizar esta acción');
            setLoading(false);
            return;
        }

        if (sucursalEditData.Departamentoid === '' || sucursalEditData.Ciudadid === '') {
            alert('Por favor selecciona el departamento y ciudad');
            setLoading(false);
            return;
        }

        postData('api/Configuracion/Company/SucursalEditPost', { CompanyId: CompanyId, Id: sucursalEditData.Id }, {
            CompanyId: CompanyId,
            Direccion: sucursalEditData.Direccion,
            Telefono: sucursalEditData.Telefono,
            Email: sucursalEditData.Email,
            NombreSucursal: sucursalEditData.Nombre,
            Codigo: sucursalEditData.Codigo,
            Municipality_Id: sucursalEditData.Ciudadid
        }, true).then(response => {

            if (response.status === true) {
                Swal.fire({ icon: 'success', title: 'Sucursal actualizada con éxito', timer: 1800, showConfirmButton: false });
                setSucursalEditOpen(false);
                sucursalesCargar();
            } else {
                alert(response.msj);
                console.log(response);
                setLoading(false);
            }

        }, error => {
            console.log(error);
            alert('Algo salió mal, por favor verifica');
            setLoading(false);
        })
    }

    const documentosLegalCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/DocumentosLegalesGet', {
            CompanyId: CompanyId
        }).then(response => {
            console.log(response.modelo);
            setDocumentosLegal(response.modelo);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal al cargar los documentos legales');
        })
    }


    const documentosLegalUpload = (Tipo = '', File) => {
        if (File != null) {
            setLoading(true);

            const formData = new FormData();
            formData.append("file", File);

            const AmbienteTae_Url = infoUser.AmbienteTae_Url;

            let UrlBase = AmbienteTae_Url +
                'api/Configuracion/Company/DocumentoLegalUpload?CompanyId=' + CompanyId + '&Tipo=' + Tipo;


            ///Pendiente asignar token aqui
            const token = infoUser.tokenSesion; //localStorage.getItem('tokenSesion');

            fetch(UrlBase, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Accept': 'application/json'
                },
                body: formData
            }).then(response => response.json())
                .then(data => {
                    if (data.status === true) {
                        documentosLegalCargar();

                        ///Función para guardar la auditoria
                        auditoriaSet({
                            Tipo: Tipo,
                            Estado: 'Carga documentos'
                        }, {}, 'C', 'Empresa', CompanyId, 'Documentos');

                    } else {
                        alert(data.msj)
                        setLoading(false);
                    }
                })
                .catch(error => {
                    alert('Algo salio mal en la peticion');
                    console.log(error);
                    setLoading(false);
                });


        }

    }


    const openNewTab = (URL = '') => {
        window.open(URL, '_blank');
    }


    const usuariosCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/UsuariosGet', {
            CompanyId: CompanyId
        }).then(response => {
            // console.log(response)
            setUsuarios(response.usuarios);
            setUsuarioAnterior(response.usuarios);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal al cargar los documentos legales');
        })
    }

    const usuarioModifica = () => {
        setLoading(true);

        postData('api/Usuario/crearUsuario', {
            User: usuarioNuevo.Usuario,
            Clave: usuarioNuevo.Contrasena,
            Usuarioid: usuarioNuevo.Usuarioid,
            Activo: usuarioNuevo.Activo
        }, false).then(response => {
            if (response.status === true) {
                alert('Usuario modificado con éxito');
            } else {
                alert(response.msj);
            }

            //Se crea el array inicial antes de los cambios
            const usuarioInicial = usuarioAnterior.filter(item => item.id === usuarioNuevo.Usuarioid)[0];
            const valueIni = {
                Usuario: usuarioInicial.email,
                Usuarioid: usuarioInicial.id,
                Contrasena: usuarioInicial.contrasena,
                ModalVisible: true
            };

            ///Función para guardar auditoría
            auditoriaSet(valueIni, usuarioNuevo, 'A', 'Empresa', CompanyId, 'UserEmpresa');

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const usuarioNuevoCrear = (event) => {
        event.preventDefault();
        setLoading(true);


        postData('api/Configuracion/Company/UsuarioCreate', {
            CompanyId: CompanyId,
            Correo: usuarioNuevo.Correo,
            Contrasena: usuarioNuevo.Contrasena
        }, {}).then(response => {

            if (response.status === true) {
                alert('Usuario creado con exito');
                setUsuarioNuevo({ ...usuarioNuevo, Nuevo: false });

                //Función para guardar la auditoria
                auditoriaSet(usuarioNuevo, {}, 'C', 'Empresa', CompanyId, 'Usuario');

                usuariosCargar();
            }
            else {
                alert(response.msj);
                console.log(response);
                setLoading(false);
            }


        }, error => {
            console.log(error);
            alert('Algo salio mal, por favor verifica');
            setLoading(false);
        })
    }

    const getEmisionInstancia = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/Company/GetEmisionesData', {
            CompanyId: CompanyId,
            MMM: buscarEmisionesInstancia.MMM,
            YYYY: buscarEmisionesInstancia.YYYY
        }).then(response => {
            console.log(response);
            setEmisionesInstancia(response);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor contacta a soporte');
        })

    }


    const sumArray = (Datos = [], Campo = '') => {
        let Valor = 0;

        Datos.forEach(item => {
            Valor += item[Campo];
        })

        return Valor;
    }


    const getEmisionesMes = () => {
        setLoading(true);

        getData('api/Configuracion/Company/GetEmisionMes_TipoDocumento', {
            CompanyId: CompanyId
        }).then(response => {
            setEmisionesMes(response.datos);
            setEmisionesMesExcel(response?.excel);
            setTotalEmisionesMes(response?.totalEmision);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor contacta a soporte');
        })


    }


    const planesCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/GetPlan', { CompanyId: CompanyId }).then(response => {
            setPlanesActuales(response.datos);
            setPlanesDisponibles(response.planes);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor contacta a soporte');
        })
    }

    const dissableUserCompany = async () => {

        if (!EstadoCompany) {
            alert("No tienes permiso para cambiar el estado de la compañia");
            return;
        }

        let messageAlert = {
            title: isActiveCompany ? "¿Estás seguro de deshabilitar la compañía?" : "¿Estás seguro en habilitar la compañía?",
            text: isActiveCompany ? "Una vez deshabilitadar se ocultará a nivel general del sistema." : "Una vez habilitada se mostrará a nivel general del sistema",
            confirmButtonText: isActiveCompany ? "Sí, deshabilitar" : "Sí, habilitar"
        }

        const { title, confirmButtonText } = messageAlert;

        Swal.fire({
            title,
            input: !isActiveCompany ? "" : "text",
            inputPlaceholder: "Motivo de inactivación",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText,
            cancelButtonText: "Cancelar",
            inputValidator: (value) => {
                if (!value) return "Debes de ingresar un valor";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const result_x = await updateActiveCompany(CompanyId, isActiveCompany, result.value);

                if (result_x?.result !== "Ok") return alert("Error en proceso");
                Swal.fire({
                    title: !isActiveCompany ? "¡Habilitado!" : "¡Deshabilitado!",
                    text: !isActiveCompany ? "La compañia ha sido habilitada" : "La compañía ha sido deshabilitada.",
                    icon: "success",
                }).then(result => {
                    if (result.isConfirmed) {
                        // Ejecutar función aquí
                        console.log("El usuario hizo clic en OK");
                        window.location.reload();
                    }
                });
            } else {
                Swal.fire({
                    title: "Cancelado",
                    text: isActiveCompany ? "La compañía seguirá habilitada." : "La compañía seguirá inhabilitada.",
                    icon: "info",
                });
            }
        });

        return;
    }


    const notasCargar = () => {
        setLoading(true);

        getData('api/Configuracion/Company/NotaCompanyGet', { CompanyId: CompanyId }).then(response => {
            console.log(response);
            setNotasCompany(response.notas);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor contacta a soporte');
        })

    }

    const verPermisosGlobales = () => {
        setLoading(true);

        getData('api/Usuario/getRollCreadosEmpresa', {
            compnayId: CompanyId,
            usuarioid: ''
        }, false).then(response => {
            setPermisoGlobal(response.permisos);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para ver permisos hijos de acuerdo a un padre
    ///Diego F Sandoval F
    ///21-08-2025
    const verPermisos = (rollpadreid, rollid) => {
        setHistorialPermiso([...historialPermiso, { permisoAnterior, rollPermiso }]); ///Asignmaos un historial donde guardamos el nivel anterior y los permisos ya establecidos
        setRollPermiso([]);

        setLoading(true);

        getData('api/Usuario/getRollGlobalDetallado', {
            rollpadreid: rollpadreid,
            rollid: rollid,
            companyId: CompanyId || ''
        }, false).then(response => {
            setRollPermiso(response.rollDetallado);
            setPermisoAnterior(permisoAnterior + 1); ////Como ya asignamos los nuevos permisos, sumamos en uno el nivel

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para poder regresar entre menús de los roles
    const regresarMenuRoles = () => {
        if (historialPermiso.length > 0) {
            setLoading(true);

            const anterior = historialPermiso[historialPermiso.length - 1]; ///Procedemos a devolvernos al historial anterior
            setRollPermiso(anterior.rollPermiso);
            setPermisoAnterior(anterior.permisoAnterior);
            setHistorialPermiso(historialPermiso.slice(0, -1));

            setLoading(false);
        }
    }

    ///Función para guardar un nuevo rol y de paso traerme la información correspondiente a los permisos
    ///Diego F Sandoval F
    ///21-08-2025
    const rolSave = () => {
        if (rolCompanyCrud.Descripcion === '') {
            alert('Por favor ingresa una descripción');
            return;
        }

        ///Buscamos todos los permisos que se modificaron para actualizarlos en BD
        let rolesActivos = rollPermiso;

        setLoading(true);

        postData('api/Usuario/guardarRol', {
            CompanyId: CompanyId,
            Descripcion: rolCompanyCrud.Descripcion,
            Activo: rolCompanyCrud.Activo,
            Rollid: rolCompanyCrud.Rollid
        }, rolesActivos, false).then(response => {
            if (!response.edit) ///Si es distinto de edit es porque es un create
                setRollPermiso(response.permisos);

            setLoading(false);
        }, error => {
            console.log(error);

            setLoading(false);
        })
    }


    const notasUpdate = () => {
        if (notaCompanyCrud.Nota === '') {
            alert('Por favor ingresa la nota antes de guardar');
            return;
        }

        if (notaCompanyCrud.Categoria === '') {
            alert('Por favor la categoria de la nota antes de guardar');
            return;
        }

        setLoading(true);

        postData('api/Configuracion/Company/NotaCompanyUpdate', { CompanyId: CompanyId }, {
            NotaId: null,
            Nota: notaCompanyCrud.Nota,
            Categoria: notaCompanyCrud.Categoria
        }, false).then(response => {

            alert(response.msj);
            setLoading(false);
            if (response.status === true) {
                setNotaCompanyCrud({ ModalVisible: false, Categoria: '', Nota: '' });
                notasCargar();
            }


        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor contacta a soporte');
        })
    }

    const probarConexion = (event) => {
        event.preventDefault();

        setLoading(true);

        getData('api/Cliente/Radian/probarConexion', {
            companyConfigId: configRadian.id
        }).then(response => {
            if (response.resultadoLectura.exitoso && response.resultadoLectura.totalCorreos > 0) {
                alert('Conexión éxitosa');

                setModalConfigRadian({
                    ModalVisible: false,
                    Titulo: ''
                });

                radianConfigList();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const crearNuevaConfigRadian = (event) => {
        event.preventDefault();

        if (!GestionConfigRadian) {
            alert('No tienes permiso para realizar esta acción');
            setLoading(false);
            return;
        }

        setLoading(true);

        let configRadianCompany = {
            id: configRadian.id === undefined ? null : configRadian.id,
            correo: configRadian.correo,
            clave: configRadian.clave,
            imapPort: configRadian.imapPort,
            imapHost: configRadian.imapHost,
            proveedor: configRadian.proveedor,
            estado: configRadian.estado,
            sslAplica: configRadian.ssl_aplica,
            correoNuevo: configRadian.correoNuevo
        };

        postData('api/Configuracion/Company/guardarConfigRadian', {
            companyId: CompanyId
        }, configRadianCompany).then(response => {
            if (response.status) {
                alert(response.msj);

                ///Si es igual a null, procede a hacer un create, de lo contrario es un edit
                if (configRadian.id === null || configRadian.id === 'null') {

                    setConfiguracionRadian(prev => [
                        ...prev,
                        {
                            correo: response.datos.correo,
                            clave: response.datos.clave,
                            imapPuerto: response.datos.imapPuerto,
                            imapHost: response.datos.imapHost,
                            proveedor: response.datos.proveedor,
                            estado: response.datos.estado,
                            sslAplica: response.datos.ssl_aplica,
                            id: response.datos.id,
                            correoNuevo: response.datos.correo
                        }
                    ]);

                    auditoriaSet(configRadianCompany, {}, 'C', 'Empresa', CompanyId, 'ConfigRadian');

                    //Seteamos valores iniciales
                    setConfigRadian({
                        clave: '',
                        correo: '',
                        estado: false,
                        imapHost: '',
                        imapPort: '',
                        nuevo: false,
                        proveedor: '',
                        ssl_aplica: false,
                        id: null,
                        correoNuevo: '',
                        buzonCompartido: ''
                    });
                } else {
                    auditoriaSet(configRadianOld, configRadianCompany, 'A', 'Empresa', CompanyId, 'ConfigRadian');

                    setModalConfigRadian({
                        ModalVisible: false,
                        Titulo: ''
                    });

                    radianConfigList();
                }

            } else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const eliminarConfigRadian = (id, item) => {
        if (!GestionConfigRadian) {
            alert('No tienes permiso para realizar esta acción');
            setLoading(false);
            return;
        }

        setLoading(true);

        getData('api/Configuracion/Company/eliminarConfigRadian', {
            configRadian: id
        }).then(response => {
            if (response.status) {
                alert('Configuración eliminada con éxito');
                setConfiguracionRadian(prev => prev.filter(item => item.id !== id));

                auditoriaSet(item, {}, 'E', 'Empresa', CompanyId, 'ConfigRadian');
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const [logoBase, setLogoBase] = useState(null);

    const convertirBase64 = async () => {
        const response = await fetch('/TAV-Saludando.png');
        const blob = await response.blob();

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
            setLogoBase(reader.result);
        };
    }

    const fileName = `Propuesta_TAE_${infoPlanCompany?.identification ?? CompanyId}.pdf`;
    const doc = <TaePdfDocumento data={infoPlanCompany} logoBase64={logoBase} />;

    const [tabActivo, setTabActivo] = useState('general');

    const handleTabChange = (_, newValue) => {
        setTabActivo(newValue);
        if (newValue === 'mailInvoice') facturaHtmlCargar();
        else if (newValue === 'sucursal') sucursalesCargar();
        else if (newValue === 'documentsLegal') { documentosLegalCargar(); visualizarAutorizacionPlan(); planesCargar(); }
        else if (newValue === 'users') usuariosCargar();
        else if (newValue === 'plans') planesCargar();
        else if (newValue === 'emisionXmes') getEmisionesMes();
        else if (newValue === 'notes') notasCargar();
        else if (newValue === 'roll') verPermisosGlobales();
        else if (newValue === 'contactos') contactoGetList();
        else if (newValue === 'radian') radianConfigList();
    };

    return (
        <Box sx={{ p: 2 }}>
            <LoadingComponent Loading={loading} />

            <Typography variant="h6" fontWeight={700} color="#224B6A" align="center" sx={{ mb: 2 }}>
                CONFIGURACIÓN DE {idenfication.Nit + ' - ' + datosNuevoEmpresa.business_name}
            </Typography>

            {/* Tabs */}
            <Paper elevation={1} sx={{ mb: 2 }}>
                <Tabs
                    value={tabActivo}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTabs-flexContainer': { flexWrap: 'wrap' },
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root': {
                            fontSize: '0.72rem', fontWeight: 700, minHeight: 36, py: 0,
                            border: '1px solid #b0c4d8', borderRadius: 1, mx: 0.3, my: 0.4,
                            color: '#224B6A',
                        },
                        '& .Mui-selected': {
                            color: '#fff !important',
                            backgroundColor: '#224B6A',
                            borderColor: '#224B6A',
                            borderRadius: 1,
                        },
                    }}
                >
                    {(EditEmpresa || VisualizarEmpresa) && <Tab label="GENERAL" value="general" />}
                    {infoUser.AdminTae === 'true' && <Tab label="NOTAS" value="notes" />}
                    {(GestionDocumentos || VisualizarDocumentos) && <Tab label="DOCUMENTOS" value="documentsLegal" />}
                    {(GestionUsuario || VisualizarUsuarios) && <Tab label="USUARIOS" value="users" />}
                    {GestionRolCompa && <Tab label="ROLES" value="roll" />}
                    {(GestionSucursal || VisualizarSucursales) && <Tab label="SUCURSALES" value="sucursal" />}
                    {(GestionLogo || VisualizaLogo) && <Tab label="LOGO" value="logo" />}
                    {GestionCorreos && <Tab label="CORREO FACTURA" value="mailInvoice" />}
                    {(GestionResoluc || EliminResolu || VisualizarResoluc) && <Tab label="RESOLUCIONES" value="resolutions" />}
                    {(GestionAmbiente || VisualizarAmbientes) && <Tab label="AMBIENTES" value="enviroments" />}
                    {(GestionPlan || VisualizaPlanes) && <Tab label="PLANES" value="plans" />}
                    {infoUser.AdminTae === 'true' && <Tab label="EMISIONES SITIO" value="emisionIntancia" />}
                    <Tab label="EMISIONES MES" value="emisionXmes" />
                    {GestionSoftware && <Tab label="SOFTWARE DIAN" value="softwareconf" />}
                    {(GestionContactos || VisualizarContactos) && <Tab label="CONTACTOS" value="contactos" />}
                    <Tab label="RADIAN" value="radian" />
                </Tabs>
            </Paper>

            {/* PANEL: GENERAL */}
            {tabActivo === 'general' && (EditEmpresa || VisualizarEmpresa) && (
                <Box component="form" onSubmit={guardar} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                    {/* Sección 1: Identificación */}
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.82rem"
                            sx={{ mb: 1.5, px: 1.5, py: 0.8, borderRadius: 1, background: '#224B6A', color: '#fff', letterSpacing: 0.3 }}>
                            IDENTIFICACIÓN
                        </Typography>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={4}>
                                <TextField label="Tipo Identificación" select fullWidth size="small" sx={inputSx}
                                    value={datosNuevoEmpresa.type_document_identification_id}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, type_document_identification_id: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {typesDocumentIdentifications.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="NIT" type="number" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ readOnly: true }}
                                    value={idenfication.Nit}
                                    onChange={e => setIdentification({ ...idenfication, Nit: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField label="DV" type="number" fullWidth size="small" sx={inputSx}
                                    required inputProps={{ min: 0, max: 9 }}
                                    value={idenfication.Dv}
                                    onChange={e => setIdentification({ ...idenfication, Dv: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Nombre de empresa" fullWidth size="small" sx={inputSx}
                                    required value={datosNuevoEmpresa.business_name}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, business_name: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Nombre Alterno" fullWidth size="small" sx={inputSx}
                                    required value={nombreAlterno}
                                    onChange={e => setNombreAlterno(e.target.value)}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* Sección 2: Información tributaria */}
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.82rem"
                            sx={{ mb: 1.5, px: 1.5, py: 0.8, borderRadius: 1, background: '#224B6A', color: '#fff', letterSpacing: 0.3 }}>
                            INFORMACIÓN TRIBUTARIA
                        </Typography>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={4}>
                                <TextField label="Tipo Organización" select fullWidth size="small" sx={inputSx}
                                    value={datosNuevoEmpresa.type_organization_id}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, type_organization_id: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {typeOrganizations.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField label="Tipo Responsabilidad" select fullWidth size="small" sx={inputSx}
                                    value={datosNuevoEmpresa.type_regime_id}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, type_regime_id: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {typeRegimens.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField label="Tipo Régimen" select fullWidth size="small" sx={inputSx}
                                    value={datosNuevoEmpresa.type_liability_id}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, type_liability_id: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {typeLiabilites.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* Sección 3: Contacto y ubicación */}
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.82rem"
                            sx={{ mb: 1.5, px: 1.5, py: 0.8, borderRadius: 1, background: '#224B6A', color: '#fff', letterSpacing: 0.3 }}>
                            CONTACTO Y UBICACIÓN
                        </Typography>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={4}>
                                <TextField label="Teléfono o Celular" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ maxLength: 10, minLength: 7 }}
                                    value={datosNuevoEmpresa.phone}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, phone: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <TextField label="Correo Electrónico" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ maxLength: 250 }}
                                    value={datosNuevoEmpresa.email}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, email: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <TextField label="Dirección" fullWidth size="small" sx={inputSx}
                                    required inputProps={{ maxLength: 250 }}
                                    value={datosNuevoEmpresa.address}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, address: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <TextField label="Registro Mercantil" fullWidth size="small" sx={inputSx}
                                    required inputProps={{ maxLength: 250 }}
                                    value={datosNuevoEmpresa.merchant_registration}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, merchant_registration: e.target.value })}
                                    disabled={infoUser.AdminTae !== 'true'} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Departamento" select fullWidth size="small" sx={inputSx}
                                    value={departmentid}
                                    onChange={e => { setDepartmentid(e.target.value); citiesLoad(e.target.value); }}
                                    disabled={infoUser.AdminTae !== 'true'}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {departamentsCities.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Ciudad" select fullWidth size="small" sx={inputSx}
                                    value={datosNuevoEmpresa.municipality_id}
                                    onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, municipality_id: Number(e.target.value) })}
                                    disabled={infoUser.AdminTae !== 'true'}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {Cities.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* Sección 4: Envío de correos (solo AdminTae) */}
                    {infoUser.AdminTae === 'true' && (
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                            <Typography fontWeight={700} color="#224B6A" fontSize="0.82rem"
                                sx={{ mb: 1.5, px: 1.5, py: 0.8, borderRadius: 1, background: '#224B6A', color: '#fff', letterSpacing: 0.3 }}>
                                ENVÍO DE CORREOS
                            </Typography>
                            <Grid container spacing={1.5}>
                                <Grid item xs={12} md={6}>
                                    <TextField label="Correo" fullWidth size="small" sx={inputSx}
                                        required value={datosNuevoEmpresa.mail_username}
                                        onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_username: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField label="Contraseña" fullWidth size="small" sx={inputSx}
                                        required value={datosNuevoEmpresa.mail_password}
                                        onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_password: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField label="Servidor Correo" fullWidth size="small" sx={inputSx}
                                        required value={datosNuevoEmpresa.mail_host}
                                        onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_host: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField label="Puerto" fullWidth size="small" sx={inputSx}
                                        required value={datosNuevoEmpresa.mail_port}
                                        onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_port: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField label="Encriptación" fullWidth size="small" sx={inputSx}
                                        required value={datosNuevoEmpresa.mail_encryption}
                                        onChange={e => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_encryption: e.target.value })} />
                                </Grid>
                            </Grid>
                        </Paper>
                    )}

                    {/* Acciones */}
                    {infoUser.AdminTae === 'true' && (
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button type="submit" variant="contained" size="small"
                                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                Guardar
                            </Button>
                            <Button variant="contained" size="small" color={isActiveCompany ? 'error' : 'success'}
                                onClick={dissableUserCompany} sx={{ fontSize: '0.78rem' }}>
                                {isActiveCompany ? 'Deshabilitar compañía' : 'Habilitar compañía'}
                            </Button>
                        </Box>
                    )}
                </Box>
            )}

            {/* PANEL: NOTAS */}
            {tabActivo === 'notes' && infoUser.AdminTae === 'true' && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">NOTAS</Typography>
                        <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                            onClick={() => setNotaCompanyCrud({ ...notaCompanyCrud, ModalVisible: true })}
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Nueva Nota
                        </Button>
                    </Box>
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderCell>Categoría</HeaderCell>
                                    <HeaderCell>Nota</HeaderCell>
                                    <HeaderCell align="center">Usuario Creación</HeaderCell>
                                    <HeaderCell align="center">Fecha Creación</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {notasCompany.length === 0 ? (
                                    <TableRow><BodyCell colSpan={4} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin notas.</BodyCell></TableRow>
                                ) : notasCompany.map((item, index) => (
                                    <StyledRow key={item.notaId} index={index}>
                                        <BodyCell align="center">{item.categoria}</BodyCell>
                                        <BodyCell>{item.nota}</BodyCell>
                                        <BodyCell align="center">{item.creacionUsuario}</BodyCell>
                                        <BodyCell align="center">{item.creacionFechaHora}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* PANEL: DOCUMENTOS */}
            {tabActivo === 'documentsLegal' && (GestionDocumentos || VisualizarDocumentos) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>DOCUMENTOS</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1 }}>RUT</Typography>
                                {documentosLegal.rut === false ? (
                                    <Typography color="error" fontWeight={700}>PENDIENTE</Typography>
                                ) : (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Button size="small" variant="contained" color="success"
                                            onClick={() => openNewTab(urlApiProduccion + 'adjuntos/' + documentosLegal.rut_Detalle.arhivoNombre)}
                                            startIcon={<FaEye size={12} />} sx={{ mb: 1, fontSize: '0.75rem' }}>VER RUT</Button>
                                        <TextField label="Fecha Cargue" fullWidth size="small" sx={{ ...inputSx, mt: 1 }}
                                            value={documentosLegal.rut_Detalle.fechaCargue} inputProps={{ readOnly: true }} />
                                    </Box>
                                )}
                                <Box sx={{ mt: 1 }}>
                                    <Typography fontSize="0.78rem" sx={{ mb: 0.5 }}>Cargue de Rut</Typography>
                                    {GestionDocumentos && (
                                        <input className="form-control form-control-sm" type="file" accept="application/pdf"
                                            onChange={file => documentosLegalUpload('RUT', file.target.files[0])} />
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1 }}>CÁMARA Y COMERCIO</Typography>
                                {documentosLegal.camaraComercio === false ? (
                                    <Typography color="error" fontWeight={700}>PENDIENTE</Typography>
                                ) : (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Button size="small" variant="contained" color="success"
                                            onClick={() => openNewTab(urlApiProduccion + 'adjuntos/' + documentosLegal.camaraComerciao_Detalle.arhivoNombre)}
                                            startIcon={<FaEye size={12} />} sx={{ mb: 1, fontSize: '0.75rem' }}>VER CÁMARA Y CCIO</Button>
                                        <TextField label="Fecha Cargue" fullWidth size="small" sx={{ ...inputSx, mt: 1 }}
                                            value={documentosLegal.camaraComerciao_Detalle.fechaCargue} inputProps={{ readOnly: true }} />
                                    </Box>
                                )}
                                <Box sx={{ mt: 1 }}>
                                    <Typography fontSize="0.78rem" sx={{ mb: 0.5 }}>Cargue de Cámara y Comercio</Typography>
                                    {GestionDocumentos && (
                                        <input className="form-control form-control-sm" type="file" accept="application/pdf"
                                            onChange={file => documentosLegalUpload('CCIO', file.target.files[0])} />
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1 }}>CÉDULA</Typography>
                                {documentosLegal.cedulaRepLegal === false ? (
                                    <Typography color="error" fontWeight={700}>PENDIENTE</Typography>
                                ) : (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Button size="small" variant="contained" color="success"
                                            onClick={() => openNewTab(urlApiProduccion + 'adjuntos/' + documentosLegal.cedulaRepLegal_Detalle.arhivoNombre)}
                                            startIcon={<FaEye size={12} />} sx={{ mb: 1, fontSize: '0.75rem' }}>VER CÉDULA</Button>
                                        <TextField label="Fecha Cargue" fullWidth size="small" sx={{ ...inputSx, mt: 1 }}
                                            value={documentosLegal.cedulaRepLegal_Detalle.fechaCargue} inputProps={{ readOnly: true }} />
                                    </Box>
                                )}
                                <Box sx={{ mt: 1 }}>
                                    <Typography fontSize="0.78rem" sx={{ mb: 0.5 }}>Cargue de Cédula</Typography>
                                    {GestionDocumentos && (
                                        <input className="form-control form-control-sm" type="file" accept="application/pdf"
                                            onChange={file => documentosLegalUpload('CEDULA', file.target.files[0])} />
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1 }}>AUTORIZACIÓN PROPUESTA COMERCIAL</Typography>
                                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                                    <TextField label="Plan sugerido" select size="small" sx={{ ...inputSx, minWidth: 220 }}
                                        value={planSugeridoSeleccionado ?? ''}
                                        onChange={e => setPlanSugeridoSeleccionado(e.target.value)}>
                                        <MenuItem value="" sx={{ fontSize: '0.82rem' }}>-- Seleccione plan sugerido --</MenuItem>
                                        {planesDispibles.filter(x => x.activo === true).map(plan => (
                                            <MenuItem key={plan.id} value={plan.id} sx={{ fontSize: '0.82rem' }}>{plan.nombre}</MenuItem>
                                        ))}
                                    </TextField>
                                    <Button size="small" variant="outlined" onClick={refrescarPropuesta}
                                        disabled={!planSugeridoSeleccionado} sx={{ fontSize: '0.75rem' }}>
                                        Refrescar Propuesta
                                    </Button>
                                    <PDFDownloadLink document={doc} fileName={fileName}>
                                        {({ loading: gen }) => (
                                            <Button size="small" variant="outlined" disabled={gen}
                                                startIcon={<FaFileDownload size={12} />} sx={{ fontSize: '0.75rem' }}>
                                                {gen ? 'Generando PDF...' : 'Descargar Propuesta'}
                                            </Button>
                                        )}
                                    </PDFDownloadLink>
                                </Box>
                                {documentosLegal.autorizacionComercial === false ? (
                                    <Typography color="error" fontWeight={700} align="center">PENDIENTE</Typography>
                                ) : (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Button size="small" variant="contained" color="success"
                                            onClick={() => openNewTab(urlApiProduccion + 'adjuntos/' + documentosLegal.autoizacionComercial_Detalle.arhivoNombre)}
                                            startIcon={<FaEye size={12} />} sx={{ mb: 1, fontSize: '0.75rem' }}>VER AUTORIZACIÓN</Button>
                                    </Box>
                                )}
                                <Box sx={{ mt: 1 }}>
                                    <Typography fontSize="0.78rem" sx={{ mb: 0.5 }}>Cargue de autorización</Typography>
                                    <input className="form-control form-control-sm" type="file" accept="application/pdf"
                                        onChange={file => documentosLegalUpload('AUTORIZACION', file.target.files[0])} />
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>
            )}

            {/* PANEL: USUARIOS */}
            {tabActivo === 'users' && (GestionUsuario || VisualizarUsuarios) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">USUARIOS</Typography>
                        <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                            onClick={() => {
                                if (!GestionUsuario) { alert('No tienes permiso para esta acción'); return; }
                                setUsuarioNuevo({ Nuevo: true, Correo: '', Contrasena: '', Activo: true });
                            }}
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Nuevo Usuario
                        </Button>
                    </Box>
                    {usuarioNuevo.Nuevo && (
                        <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid #e2e8f0' }}>
                            <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1.5 }}>Nuevo Usuario</Typography>
                            <Box component="form" onSubmit={usuarioNuevoCrear}>
                                <Grid container spacing={1.5} alignItems="flex-end">
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Correo" type="email" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" value={usuarioNuevo.Correo}
                                            onChange={e => setUsuarioNuevo({ ...usuarioNuevo, Correo: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Contraseña" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 250 }}
                                            value={usuarioNuevo.Contrasena}
                                            onChange={e => setUsuarioNuevo({ ...usuarioNuevo, Contrasena: e.target.value })} />
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button type="submit" variant="contained" size="small"
                                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                            Guardar
                                        </Button>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button variant="contained" color="error" size="small" sx={{ fontSize: '0.78rem' }}
                                            onClick={() => setUsuarioNuevo({ Nuevo: false, Correo: '', Contrasena: '', Activo: true })}>
                                            Cancelar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    )}
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderCell align="center">Acción</HeaderCell>
                                    <HeaderCell>Usuario</HeaderCell>
                                    <HeaderCell align="center">Contraseña</HeaderCell>
                                    <HeaderCell align="center">Facturación</HeaderCell>
                                    <HeaderCell align="center">Nómina</HeaderCell>
                                    <HeaderCell align="center">Doc Equiv</HeaderCell>
                                    <HeaderCell align="center">Radian</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {usuarios.length === 0 ? (
                                    <TableRow><BodyCell colSpan={7} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin usuarios.</BodyCell></TableRow>
                                ) : usuarios.map((item, key) => (
                                    <StyledRow key={key} index={key}>
                                        <BodyCell align="center">
                                            <Tooltip title="Editar usuario">
                                                <IconButton size="small" sx={{ color: '#1976d2' }} onClick={() => {
                                                    if (!GestionUsuario) { alert('No tienes permiso para esta acción'); return; }
                                                    setRollPermiso([]);
                                                    setUsuarioNuevo({ ModalVisible: true, Usuario: item.email, Contrasena: item.contrasena, Usuarioid: item.id, Activo: item.activo });
                                                }}>
                                                    <FaEdit size={14} />
                                                </IconButton>
                                            </Tooltip>
                                        </BodyCell>
                                        <BodyCell>{item.email}</BodyCell>
                                        <BodyCell align="center">***********</BodyCell>
                                        <BodyCell align="center"><FaCheck size={14} color="#16a34a" /></BodyCell>
                                        <BodyCell align="center"><FaCheck size={14} color="#16a34a" /></BodyCell>
                                        <BodyCell align="center"><FaCheck size={14} color="#16a34a" /></BodyCell>
                                        <BodyCell align="center"><FaCheck size={14} color="#16a34a" /></BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* PANEL: ROLES */}
            {tabActivo === 'roll' && GestionRolCompa && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">ROLES</Typography>
                        <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                            onClick={() => setRolCompanyCrud({ ...rolCompanyCrud, ModalVisible: true, Titulo: 'Nuevo rol', Descripcion: '', Activo: true, Rollid: '' })}
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Nuevo Rol
                        </Button>
                    </Box>
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderCell align="center">Acción</HeaderCell>
                                    <HeaderCell>Descripción</HeaderCell>
                                    <HeaderCell align="center">Activo</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rollPermisoGlobal.length === 0 ? (
                                    <TableRow><BodyCell colSpan={3} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin roles.</BodyCell></TableRow>
                                ) : rollPermisoGlobal.map((item, index) => (
                                    <StyledRow key={item.rollid} index={index}>
                                        <BodyCell align="center">
                                            <Tooltip title="Editar rol">
                                                <IconButton size="small" sx={{ color: '#1976d2' }} onClick={() => {
                                                    setRolCompanyCrud({ ...rolCompanyCrud, ModalVisible: true, Titulo: 'Editar rol', Descripcion: item.descripcion, Activo: item.activo, Rollid: item.rollid });
                                                    verPermisos('', item.rollid);
                                                }}>
                                                    <FaEdit size={14} />
                                                </IconButton>
                                            </Tooltip>
                                        </BodyCell>
                                        <BodyCell>{item.descripcion}</BodyCell>
                                        <BodyCell align="center">{item.activo ? <FaCheck size={14} color="#16a34a" /> : <FaXmark size={14} color="#dc2626" />}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* PANEL: SUCURSALES */}
            {tabActivo === 'sucursal' && (GestionSucursal || VisualizarSucursales) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">SUCURSALES</Typography>
                        {infoUser.AdminTae === 'true' && (
                            <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                                onClick={() => SetSucursalData({ Nuevo: true, Codigo: '', Nombre: '', Direccion: '', Telefono: '', Email: '', Departamentoid: '', Ciudadid: '' })}
                                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                Nueva Sucursal
                            </Button>
                        )}
                    </Box>
                    {sucursalData.Nuevo && (
                        <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid #e2e8f0' }}>
                            <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1.5 }}>Nueva Sucursal</Typography>
                            <Box component="form" onSubmit={sucursalCrearNueva}>
                                <Grid container spacing={1.5} alignItems="flex-end">
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Código" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 5 }}
                                            value={sucursalData.Codigo}
                                            onChange={e => SetSucursalData({ ...sucursalData, Codigo: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <TextField label="Nombre" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 250 }}
                                            value={sucursalData.Nombre}
                                            onChange={e => SetSucursalData({ ...sucursalData, Nombre: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Dirección" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 250 }}
                                            value={sucursalData.Direccion}
                                            onChange={e => SetSucursalData({ ...sucursalData, Direccion: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Teléfono" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 20 }}
                                            value={sucursalData.Telefono}
                                            onChange={e => SetSucursalData({ ...sucursalData, Telefono: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Email" type="email" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off"
                                            value={sucursalData.Email}
                                            onChange={e => SetSucursalData({ ...sucursalData, Email: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Departamento" select fullWidth size="small" sx={inputSx}
                                            required value={sucursalData.Departamentoid}
                                            onChange={e => { SetSucursalData({ ...sucursalData, Departamentoid: e.target.value }); citiesLoad(e.target.value); }}>
                                            <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                            {departamentsCities.map((item, key) =>
                                                <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Ciudad" select fullWidth size="small" sx={inputSx}
                                            required value={sucursalData.Ciudadid}
                                            onChange={e => SetSucursalData({ ...sucursalData, Ciudadid: e.target.value })}>
                                            <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                            {Cities.map((item, key) =>
                                                <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button type="submit" variant="contained" size="small"
                                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                            Guardar
                                        </Button>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button variant="contained" color="error" size="small" sx={{ fontSize: '0.78rem' }}
                                            onClick={() => SetSucursalData({ Nuevo: false, Codigo: '', Nombre: '', Direccion: '', Telefono: '', Email: '', Departamentoid: '', Ciudadid: '' })}>
                                            Cancelar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    )}
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {infoUser.AdminTae === 'true' && <HeaderCell align="center">Acción</HeaderCell>}
                                    <HeaderCell>Código</HeaderCell>
                                    <HeaderCell>Nombre</HeaderCell>
                                    <HeaderCell>Dirección</HeaderCell>
                                    <HeaderCell>Teléfono</HeaderCell>
                                    <HeaderCell>Email</HeaderCell>
                                    <HeaderCell>Ciudad</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sucursales.length === 0 ? (
                                    <TableRow><BodyCell colSpan={infoUser.AdminTae === 'true' ? 7 : 6} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin sucursales.</BodyCell></TableRow>
                                ) : sucursales.map((item, key) => (
                                    <StyledRow key={key} index={key}>
                                        {infoUser.AdminTae === 'true' && (
                                            <BodyCell align="center">
                                                <Tooltip title="Editar sucursal">
                                                    <IconButton size="small" color="primary" onClick={() => sucursalCargarDetalle(item)}>
                                                        <FaEdit size={14} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Eliminar sucursal">
                                                    <IconButton size="small" color="error" onClick={() => { if (!GestionSucursal) alert('No tienes permiso para eliminar sucursales'); }}>
                                                        <FaRegTrashAlt size={14} />
                                                    </IconButton>
                                                </Tooltip>
                                            </BodyCell>
                                        )}
                                        <BodyCell>{item.codigo}</BodyCell>
                                        <BodyCell>{item.name}</BodyCell>
                                        <BodyCell>{item.direccion}</BodyCell>
                                        <BodyCell>{item.telefono}</BodyCell>
                                        <BodyCell>{item.email}</BodyCell>
                                        <BodyCell>{item.ciudad}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* MODAL: EDITAR SUCURSAL */}
            <Dialog open={sucursalEditOpen} onClose={() => setSucursalEditOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.95rem">Editar Sucursal</Typography>
                    <IconButton size="small" onClick={() => setSucursalEditOpen(false)}><MdClose size={18} /></IconButton>
                </DialogTitle>
                <Box component="form" onSubmit={sucursalActualizar}>
                    <DialogContent dividers>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={3}>
                                <TextField label="Código" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ maxLength: 5 }}
                                    value={sucursalEditData.Codigo}
                                    onChange={e => setSucursalEditData({ ...sucursalEditData, Codigo: e.target.value })} />
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <TextField label="Nombre" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ maxLength: 250 }}
                                    value={sucursalEditData.Nombre}
                                    onChange={e => setSucursalEditData({ ...sucursalEditData, Nombre: e.target.value })} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Dirección" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ maxLength: 250 }}
                                    value={sucursalEditData.Direccion}
                                    onChange={e => setSucursalEditData({ ...sucursalEditData, Direccion: e.target.value })} />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField label="Teléfono" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off" inputProps={{ maxLength: 20 }}
                                    value={sucursalEditData.Telefono}
                                    onChange={e => setSucursalEditData({ ...sucursalEditData, Telefono: e.target.value })} />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField label="Email" type="email" fullWidth size="small" sx={inputSx}
                                    required autoComplete="off"
                                    value={sucursalEditData.Email}
                                    onChange={e => setSucursalEditData({ ...sucursalEditData, Email: e.target.value })} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Departamento" select fullWidth size="small" sx={inputSx}
                                    required value={sucursalEditData.Departamentoid}
                                    onChange={e => { setSucursalEditData({ ...sucursalEditData, Departamentoid: e.target.value }); citiesLoad(e.target.value); }}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {departamentsCities.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Ciudad" select fullWidth size="small" sx={inputSx}
                                    required value={sucursalEditData.Ciudadid}
                                    onChange={e => setSucursalEditData({ ...sucursalEditData, Ciudadid: e.target.value })}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                    {Cities.map((item, key) =>
                                        <MenuItem key={key} value={item.value} sx={{ fontSize: '0.82rem' }}>{item.text}</MenuItem>)}
                                </TextField>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, py: 1.5 }}>

                        <Button type="submit" variant="contained" size="small"
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Actualizar
                        </Button>

                        <Button variant="outlined" color="error" size="small" sx={{ fontSize: '0.78rem' }}
                            onClick={() => setSucursalEditOpen(false)}>
                            Cancelar
                        </Button>

                    </DialogActions>
                </Box>
            </Dialog>

            {/* PANEL: LOGO */}
            {tabActivo === 'logo' && (GestionLogo || VisualizaLogo) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>LOGO</Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography fontSize="0.82rem" sx={{ mb: 0.5 }}>Logo de la empresa</Typography>
                            <input className="form-control form-control-sm" type="file" accept="image/png, image/jpeg" onChange={procesarLogo} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button variant="contained" color="success" size="small" onClick={cargarLogo} sx={{ fontSize: '0.78rem' }}>
                                Actualizar
                            </Button>
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 2 }}>{getLogo()}</Box>
                </Paper>
            )}

            {/* PANEL: CORREO FACTURA */}
            {tabActivo === 'mailInvoice' && GestionCorreos && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>FORMATO DE ENVÍO DE FACTURAS</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography fontSize="0.82rem" sx={{ mb: 0.5 }}>Encabezado de correo</Typography>
                            <textarea rows={5} value={htmlFactura.header}
                                onChange={e => setHtmlFactura({ ...htmlFactura, header: e.target.value })}
                                className="form-control form-control-sm" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <span dangerouslySetInnerHTML={{ __html: htmlFactura.header }} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography fontSize="0.82rem" sx={{ mb: 0.5 }}>Cuerpo de correo</Typography>
                            <textarea rows={5} value={htmlFactura.body}
                                onChange={e => setHtmlFactura({ ...htmlFactura, body: e.target.value })}
                                className="form-control form-control-sm" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <span dangerouslySetInnerHTML={{ __html: htmlFactura.body }} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography fontSize="0.82rem" sx={{ mb: 0.5 }}>Pie de página de correo</Typography>
                            <textarea rows={5} value={htmlFactura.footer}
                                onChange={e => setHtmlFactura({ ...htmlFactura, footer: e.target.value })}
                                className="form-control form-control-sm" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <span dangerouslySetInnerHTML={{ __html: htmlFactura.footer }} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField label="Formato Factura POS" select fullWidth size="small" sx={inputSx}
                                value={htmlFactura.templateFacturaPos}
                                onChange={e => setHtmlFactura({ ...htmlFactura, templateFacturaPos: e.target.value })}>
                                {[{ id: '0', name: 'Estándar' }, { id: '6', name: 'Moderno 6' }].map((item, index) => (
                                    <MenuItem key={index} value={item.id} sx={{ fontSize: '0.82rem' }}>{item.name}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Button variant="contained" size="small" onClick={facturaHtmlUpdate}
                                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                Actualizar
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            )}

            {/* PANEL: RESOLUCIONES */}
            {tabActivo === 'resolutions' && (GestionResoluc || EliminResolu || VisualizarResoluc) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>RESOLUCIONES</Typography>
                    <Resoluciones
                        FacturacionAmbiente={facturacionAmbiente}
                        CompanySelect={{ id: CompanyId, user_Api_Token: companyToken }}
                        Permiso={EliminResolu}
                        GestionResoluc={GestionResoluc}
                        Es_Cliente={infoUser.AdminTae}
                    />
                </Paper>
            )}

            {/* PANEL: AMBIENTES */}
            {tabActivo === 'enviroments' && (GestionAmbiente || VisualizarAmbientes) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>AMBIENTES DE PROCESOS</Typography>
                    <Grid container spacing={2}>
                        {[
                            { label: 'Facturación', value: facturacionAmbiente, fn: facturaCambiaAmbiente },
                            { label: 'Nómina', value: nominaAmbiente, fn: nominaCambiaAmbiente },
                            { label: 'Documentos Equivalentes', value: docEquivAmbiente, fn: docEquivCambiaAmbiente },
                            { label: 'Documento Soporte', value: docSoporte, fn: docSoporteCambiaAmbiente },
                            { label: 'Eventos RADIAN', value: eventoRadian, fn: EventoRadianCambiaAmbiente },
                        ].map(({ label, value, fn }) => (
                            <Grid item xs={12} md={6} key={label}>
                                <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                                    <Typography fontWeight={600} fontSize="0.85rem" sx={{ mb: 1 }}>{label}</Typography>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <TextField size="small" fullWidth sx={inputSx}
                                            value={value === '2' ? 'Pruebas' : 'Producción'} inputProps={{ readOnly: true }} />
                                        <Button variant="contained" size="small"
                                            color={value === '2' ? 'success' : 'warning'}
                                            onClick={() => fn(value === '2' ? '1' : '2')}
                                            sx={{ whiteSpace: 'nowrap', fontSize: '0.72rem' }}>
                                            {value === '2' ? 'Pasar a Producción' : 'Pasar a Pruebas'}
                                        </Button>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            )}

            {/* PANEL: PLANES */}
            {tabActivo === 'plans' && (GestionPlan || VisualizaPlanes) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>PLANES DE FACTURACIÓN</Typography>
                    <Planes
                        setLoading={setLoading}
                        PlanesDisponibles={planesDispibles}
                        PlanesActuales={planesActuales}
                        CompanyId={CompanyId}
                        Permiso={GestionPlan}
                        Es_Cliente={infoUser.AdminTae}
                        Nit={idenfication.Nit}
                        NameCompany={datosEmpresa.business_name}
                    />
                </Paper>
            )}

            {/* PANEL: EMISIONES SITIO */}
            {tabActivo === 'emisionIntancia' && infoUser.AdminTae === 'true' && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>EMISIONES POR INSTANCIA</Typography>
                    <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }} component="form" onSubmit={getEmisionInstancia}>
                        <Grid container spacing={1.5} alignItems="flex-end">
                            <Grid item xs={12} md={4}>
                                <TextField label="Mes" select fullWidth size="small" sx={inputSx}
                                    value={buscarEmisionesInstancia.MMM}
                                    onChange={e => setBuscarEmisionesInstancia({ ...buscarEmisionesInstancia, MMM: e.target.value })}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>TODOS</MenuItem>
                                    {[{ id: 1, name: 'Enero' }, { id: 2, name: 'Febrero' }, { id: 3, name: 'Marzo' },
                                    { id: 4, name: 'Abril' }, { id: 5, name: 'Mayo' }, { id: 6, name: 'Junio' },
                                    { id: 7, name: 'Julio' }, { id: 8, name: 'Agosto' }, { id: 9, name: 'Septiembre' },
                                    { id: 10, name: 'Octubre' }, { id: 11, name: 'Noviembre' }, { id: 12, name: 'Diciembre' }].map((item, index) => (
                                        <MenuItem key={index} value={item.id} sx={{ fontSize: '0.82rem' }}>{item.name}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField label="Año" select fullWidth size="small" sx={inputSx}
                                    value={buscarEmisionesInstancia.YYYY}
                                    onChange={e => setBuscarEmisionesInstancia({ ...buscarEmisionesInstancia, YYYY: e.target.value })}>
                                    <MenuItem value="" sx={{ fontSize: '0.82rem' }}>TODOS</MenuItem>
                                    {[2024, 2025, 2026].map((item, index) => (
                                        <MenuItem key={index} value={item} sx={{ fontSize: '0.82rem' }}>{item}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Button type="submit" variant="contained" size="small"
                                    sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderCell>Instancia</HeaderCell>
                                    <HeaderCell align="center">Mes</HeaderCell>
                                    <HeaderCell align="center">Año</HeaderCell>
                                    <HeaderCell align="center">Prefijo</HeaderCell>
                                    <HeaderCell align="center">Emitidas</HeaderCell>
                                    <HeaderCell align="center">Pendientes</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {emisionesInstancia.length === 0 ? (
                                    <TableRow><BodyCell colSpan={6} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin datos.</BodyCell></TableRow>
                                ) : emisionesInstancia.map((item, index) => (
                                    <StyledRow key={index} index={index}>
                                        <BodyCell>{item.url}</BodyCell>
                                        <BodyCell align="center">{item.mmm}</BodyCell>
                                        <BodyCell align="center">{item.yyyy}</BodyCell>
                                        <BodyCell align="center">{item.prefijo}</BodyCell>
                                        <BodyCell align="center"><NumericFormat displayType="text" thousandSeparator="," value={item.emitidas} /></BodyCell>
                                        <BodyCell align="center"><NumericFormat displayType="text" thousandSeparator="," value={item.pendiente} /></BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* PANEL: EMISIONES MES */}
            {tabActivo === 'emisionXmes' && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">EMISIONES POR MES</Typography>
                        <Tooltip title="Descargar Excel">
                            <IconButton size="small" onClick={descargarExcel} sx={{ color: '#224B6A' }}>
                                <FaDownload size={15} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderCell>Año</HeaderCell>
                                    <HeaderCell>Mes</HeaderCell>
                                    <HeaderCell>Detalle</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {emisionesMes?.map((item, index) => (
                                    <StyledRow key={index} index={index}>
                                        <BodyCell>{item.ano}</BodyCell>
                                        <BodyCell>{moment().month(item.mes - 1).format('MMMM')}</BodyCell>
                                        <BodyCell>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ fontSize: '0.73rem', fontWeight: 'bold', width: '70%' }}>Tipo</TableCell>
                                                        <TableCell sx={{ fontSize: '0.73rem', fontWeight: 'bold' }}>Cantidad</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {item.emision_TipoDocumentos?.map((item2, i2) => (
                                                        <TableRow key={i2}>
                                                            <TableCell sx={{ fontSize: '0.73rem' }}>{item2?.tipoDocumento}</TableCell>
                                                            <TableCell align="center" sx={{ fontSize: '0.73rem' }}>
                                                                <NumericFormat displayType="text" thousandSeparator="," value={item2?.cantidad} />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <tfoot>
                                                    <TableRow sx={{ backgroundColor: '#dbeafe' }}>
                                                        <TableCell sx={{ fontSize: '0.73rem', fontWeight: 'bold' }}>Total</TableCell>
                                                        <TableCell align="center" sx={{ fontSize: '0.73rem', fontWeight: 'bold' }}>
                                                            <NumericFormat displayType="text" thousandSeparator="," value={sumArray(item?.emision_TipoDocumentos, 'cantidad')} />
                                                        </TableCell>
                                                    </TableRow>
                                                </tfoot>
                                            </Table>
                                        </BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Typography textAlign="right" fontWeight="bold" sx={{ mt: 1, mr: 3, fontSize: '0.82rem' }}>
                        Total emisión:{' '}
                        <NumericFormat displayType="text" thousandSeparator="," value={totalEmisionesMes} />
                    </Typography>
                </Paper>
            )}

            {/* PANEL: SOFTWARE DIAN */}
            {tabActivo === 'softwareconf' && GestionSoftware && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem" sx={{ mb: 2 }}>CONFIGURACIÓN SOFTWARE</Typography>
                    <Grid container justifyContent="center" spacing={4}>
                        <Grid item sx={{ textAlign: 'center' }}>
                            <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>Certificados</Typography>
                            <Tooltip title={softwareValues.certificates === 0 ? 'Agregar Certificado' : 'Ver Certificado'}>
                                <IconButton onClick={certificateModalAbrir}
                                    sx={{ color: softwareValues.certificates === 0 ? '#f59e0b' : '#64748b', border: '1px solid currentColor' }}>
                                    {softwareValues.certificates === 0 ? <FaPlus size={18} /> : <FaEye size={18} />}
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        {infoUser.AdminTae === 'true' && (
                            <Grid item sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>Facturación Electrónica</Typography>
                                <Tooltip title="Ver configuración FE">
                                    <IconButton onClick={softwareModalAbrir} sx={{ color: '#64748b', border: '1px solid currentColor' }}>
                                        <FaEye size={18} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        )}
                        {infoUser.AdminTae === 'true' && (
                            <Grid item sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>Nómina</Typography>
                                <Tooltip title="Ver configuración Nómina">
                                    <IconButton onClick={nominaSoftwareModalAbrir} sx={{ color: '#64748b', border: '1px solid currentColor' }}>
                                        <FaEye size={18} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        )}
                        {infoUser.AdminTae === 'true' && (
                            <Grid item sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>POS</Typography>
                                <Tooltip title="Ver configuración POS">
                                    <IconButton onClick={posSoftwareModalAbrir} sx={{ color: '#64748b', border: '1px solid currentColor' }}>
                                        <FaEye size={18} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        )}
                        {infoUser.AdminTae === 'true' && (
                            <Grid item sx={{ textAlign: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>Documento Soporte</Typography>
                                <Tooltip title="Ver configuración Documento Soporte">
                                    <IconButton onClick={DocumentoSoporteSoftwareModalAbrir} sx={{ color: '#64748b', border: '1px solid currentColor' }}>
                                        <FaEye size={18} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        )}
                    </Grid>
                    <EmpresaCertificadoCrud Show={certificateModal} cerrarModal={() => setCertificateModal(false)} CompanySelect={companySelect} Nuevo={false} Es_Cliente={infoUser.AdminTae} />
                    <EmpresaSoftwareCrud Show={softwareModal} cerrarModal={() => setSoftwareModal(false)} CompanySelect={companySelect} />
                    <EmpresaNominaSoftwareCrud Show={nominaSoftwareModal} cerrarModal={() => setNominaSoftwareModal(false)} CompanySelect={companySelect} />
                    <EmpresaPOSSoftware Show={posSoftwareModal} cerrarModal={() => setPOSSoftwareModal(false)} CompanySelect={companySelect} />
                    <EmpresaDSoporteSoftware Show={documentoSoporteSoftwareModal} cerrarModal={() => setDocumentoSoporteSoftwareModal(false)} CompanySelect={companySelect} />
                </Paper>
            )}

            {/* PANEL: CONTACTOS */}
            {tabActivo === 'contactos' && (GestionContactos || VisualizarContactos) && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">CONTACTOS</Typography>
                        <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                            onClick={() => setInfoContactos({ nuevo: true, cargo: '', correo: '', nombrecompleto: '', telefono: '' })}
                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                            Nuevo Contacto
                        </Button>
                    </Box>
                    {infoContactos.nuevo && (
                        <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid #e2e8f0' }}>
                            <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1.5 }}>Nuevo Contacto</Typography>
                            <Box component="form" onSubmit={crearNuevoContacto}>
                                <Grid container spacing={1.5} alignItems="flex-end">
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Nombre completo" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 200 }}
                                            value={infoContactos.nombrecompleto}
                                            onChange={e => setInfoContactos({ ...infoContactos, nombrecompleto: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Correo" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 250 }}
                                            value={infoContactos.correo}
                                            onChange={e => setInfoContactos({ ...infoContactos, correo: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Teléfono" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 250 }}
                                            value={infoContactos.telefono}
                                            onChange={e => setInfoContactos({ ...infoContactos, telefono: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Cargo" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 20 }}
                                            value={infoContactos.cargo}
                                            onChange={e => setInfoContactos({ ...infoContactos, cargo: e.target.value })} />
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button type="submit" variant="contained" size="small"
                                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                            Guardar
                                        </Button>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button variant="contained" color="error" size="small" sx={{ fontSize: '0.78rem' }}
                                            onClick={() => setInfoContactos({ nuevo: false, cargo: '', correo: '', nombrecompleto: '', telefono: '' })}>
                                            Cancelar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    )}
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {EliminarContactos && <HeaderCell align="center">Acción</HeaderCell>}
                                    <HeaderCell>Nombre</HeaderCell>
                                    <HeaderCell>Correo</HeaderCell>
                                    <HeaderCell>Teléfono</HeaderCell>
                                    <HeaderCell>Cargo</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {contactos.length === 0 ? (
                                    <TableRow><BodyCell colSpan={EliminarContactos ? 5 : 4} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin contactos.</BodyCell></TableRow>
                                ) : contactos.map((item, key) => (
                                    <StyledRow key={key} index={key}>
                                        {EliminarContactos && (
                                            <BodyCell align="center">
                                                <Tooltip title="Eliminar contacto">
                                                    <IconButton size="small" color="error" onClick={() => eliminarContacto(item.companycontactoid, item)}>
                                                        <FaRegTrashAlt size={14} />
                                                    </IconButton>
                                                </Tooltip>
                                            </BodyCell>
                                        )}
                                        <BodyCell>{item.nombre}</BodyCell>
                                        <BodyCell>{item.correo}</BodyCell>
                                        <BodyCell>{item.telefono}</BodyCell>
                                        <BodyCell>{item.cargo}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* PANEL: RADIAN */}
            {tabActivo === 'radian' && (
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography fontWeight={700} color="#224B6A" fontSize="0.88rem">CONFIGURACIÓN RADIAN</Typography>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button variant="contained" size="small" startIcon={<FaPlus size={11} />}
                                onClick={() => setConfigRadian({ nuevo: true, correo: '', clave: '', estado: false, fechaUltSincro: '', imapHost: '', imapPort: '', proveedor: '', ssl_aplica: false, id: null, correoNuevo: '', buzonCompartido: '' })}
                                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                Nueva Config.
                            </Button>
                            <Tooltip title="Información de interés">
                                <IconButton size="small" sx={{ color: '#1976d2' }} onClick={() => setMostrarImap(true)}>
                                    <FaInfo size={14} />
                                </IconButton>
                            </Tooltip>
                            {mostrarImap && <ImapConfigurationModal onClose={() => setMostrarImap(false)} />}
                        </Box>
                    </Box>
                    {configRadian.nuevo && (
                        <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid #e2e8f0' }}>
                            <Typography fontWeight={700} color="#1976d2" fontSize="0.82rem" sx={{ mb: 1.5 }}>Nueva Configuración</Typography>
                            <Box component="form" onSubmit={crearNuevaConfigRadian}>
                                <Grid container spacing={1.5} alignItems="flex-end">
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Correo" type="email" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 200 }}
                                            value={configRadian.correo}
                                            onChange={e => setConfigRadian({ ...configRadian, correo: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField label="Contraseña" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off" inputProps={{ maxLength: 250 }}
                                            value={configRadian.clave}
                                            onChange={e => setConfigRadian({ ...configRadian, clave: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="Proveedor" select fullWidth size="small" sx={inputSx}
                                            value={configRadian.proveedor}
                                            onChange={e => setConfigRadian({ ...configRadian, proveedor: e.target.value })}>
                                            <MenuItem value="null" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                            <MenuItem value="Gmail" sx={{ fontSize: '0.82rem' }}>Gmail</MenuItem>
                                            <MenuItem value="Outlook" sx={{ fontSize: '0.82rem' }}>Outlook</MenuItem>
                                            <MenuItem value="Aws" sx={{ fontSize: '0.82rem' }}>Aws</MenuItem>
                                            <MenuItem value="Otro" sx={{ fontSize: '0.82rem' }}>Otro</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={1}>
                                        <FormControlLabel
                                            control={<Checkbox size="small" checked={configRadian.estado} onChange={e => setConfigRadian({ ...configRadian, estado: e.target.checked })} />}
                                            label={<Typography fontSize="0.78rem">Activo</Typography>} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="IMAP Host" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off"
                                            value={configRadian.imapHost}
                                            onChange={e => setConfigRadian({ ...configRadian, imapHost: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField label="IMAP Puerto" type="number" fullWidth size="small" sx={inputSx}
                                            required autoComplete="off"
                                            value={configRadian.imapPort}
                                            onChange={e => setConfigRadian({ ...configRadian, imapPort: e.target.value })} />
                                    </Grid>
                                    <Grid item xs={12} md={1}>
                                        <FormControlLabel
                                            control={<Checkbox size="small" checked={configRadian.ssl_aplica} onChange={e => setConfigRadian({ ...configRadian, ssl_aplica: e.target.checked })} />}
                                            label={<Typography fontSize="0.78rem">SSL</Typography>} />
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button type="submit" variant="contained" size="small"
                                            sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                            Guardar
                                        </Button>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button variant="contained" color="error" size="small" sx={{ fontSize: '0.78rem' }}
                                            onClick={() => setConfigRadian({ nuevo: false, correo: '', clave: '', estado: false, fechaUltSincro: '', imapHost: '', imapPort: '', proveedor: '', ssl_aplica: false, id: null, correoNuevo: '', buzonCompartido: '' })}>
                                            Cancelar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    )}
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <HeaderCell align="center">Acciones</HeaderCell>
                                    <HeaderCell>Correo</HeaderCell>
                                    <HeaderCell>IMAP Host</HeaderCell>
                                    <HeaderCell align="center">IMAP Puerto</HeaderCell>
                                    <HeaderCell>Proveedor</HeaderCell>
                                    <HeaderCell align="center">Estado</HeaderCell>
                                    <HeaderCell align="center">Validado</HeaderCell>
                                    <HeaderCell align="center">Última Sincronización</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {configuracionRadian?.length === 0 ? (
                                    <TableRow><BodyCell colSpan={8} align="center" sx={{ color: '#9ca3af', py: 4 }}>Sin configuraciones.</BodyCell></TableRow>
                                ) : configuracionRadian?.map((item, key) => (
                                    <StyledRow key={key} index={key}>
                                        <BodyCell align="center">
                                            <Tooltip title="Editar configuración">
                                                <IconButton size="small" sx={{ color: '#1976d2' }} onClick={() => {
                                                    setConfigRadianOld({ correo: item.correo, id: item.id, clave: item.clave, estado: item.estado, imapHost: item.imapHost, imapPort: item.imapPuerto, proveedor: item.proveedor, ssl_aplica: item.aplicaSsl, correoNuevo: item.correo, buzonCompartido: item.buzonCompartido });
                                                    setConfigRadian({ correo: item.correo, id: item.id, clave: item.clave, estado: item.estado, imapHost: item.imapHost, imapPort: item.imapPuerto, proveedor: item.proveedor, ssl_aplica: item.aplicaSsl, correoNuevo: item.correo, buzonCompartido: item.buzonCompartido });
                                                    setModalConfigRadian({ ModalVisible: true, Titulo: 'Editar configuración RADIAN ' + item.correo });
                                                }}>
                                                    <FaEdit size={14} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Eliminar configuración">
                                                <IconButton size="small" color="error" onClick={() => eliminarConfigRadian(item.id, item)}>
                                                    <FaRegTrashAlt size={14} />
                                                </IconButton>
                                            </Tooltip>
                                        </BodyCell>
                                        <BodyCell>{item.correo}</BodyCell>
                                        <BodyCell>{item.imapHost}</BodyCell>
                                        <BodyCell align="center">{item.imapPuerto}</BodyCell>
                                        <BodyCell>{item.proveedor}</BodyCell>
                                        <BodyCell align="center">{item.estado ? <FaCheck size={14} color="#16a34a" /> : <FaXmark size={14} color="#dc2626" />}</BodyCell>
                                        <BodyCell align="center">{item.validado ? <FaCheck size={14} color="#16a34a" /> : <FaXmark size={14} color="#dc2626" />}</BodyCell>
                                        <BodyCell align="center">{formatDateddMMyyyyhhmm(item.fechaUltSincro)}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}

            {/* MODAL: RADIAN CONFIG */}
            <Dialog open={modalConfigRadian.ModalVisible}
                onClose={() => { setModalConfigRadian({ ...modalConfigRadian, ModalVisible: false, Titulo: '', Datos: {} }); setConfigRadian({}); }}
                maxWidth="lg" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">{modalConfigRadian.Titulo}</Typography>
                    <IconButton size="small" onClick={() => { setModalConfigRadian({ ...modalConfigRadian, ModalVisible: false, Titulo: '', Datos: {} }); setConfigRadian({}); }} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
                        <Grid item xs={12} md={4}>
                            <TextField label="Correo" type="email" fullWidth size="small" sx={inputSx}
                                required autoComplete="off" inputProps={{ maxLength: 200 }}
                                value={configRadian.correoNuevo || ''}
                                onChange={e => setConfigRadian({ ...configRadian, correoNuevo: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField label="Contraseña" fullWidth size="small" sx={inputSx}
                                required autoComplete="off" inputProps={{ maxLength: 250 }}
                                value={configRadian.clave || ''}
                                onChange={e => setConfigRadian({ ...configRadian, clave: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <FormControlLabel
                                control={<Checkbox size="small" checked={configRadian.estado || false} onChange={e => setConfigRadian({ ...configRadian, estado: e.target.checked })} />}
                                label={<Typography fontSize="0.78rem">Activo</Typography>} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="Proveedor" select fullWidth size="small" sx={inputSx}
                                value={configRadian.proveedor || 'null'}
                                onChange={e => setConfigRadian({ ...configRadian, proveedor: e.target.value })}>
                                <MenuItem value="null" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                <MenuItem value="Gmail" sx={{ fontSize: '0.82rem' }}>Gmail</MenuItem>
                                <MenuItem value="Outlook" sx={{ fontSize: '0.82rem' }}>Outlook personal</MenuItem>
                                <MenuItem value="OutlookComp" sx={{ fontSize: '0.82rem' }}>Outlook compartido</MenuItem>
                                <MenuItem value="Aws" sx={{ fontSize: '0.82rem' }}>Aws</MenuItem>
                                <MenuItem value="Custom" sx={{ fontSize: '0.82rem' }}>Otro</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="IMAP Host" fullWidth size="small" sx={inputSx}
                                required autoComplete="off"
                                value={configRadian.imapHost || ''}
                                onChange={e => setConfigRadian({ ...configRadian, imapHost: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="IMAP Puerto" type="number" fullWidth size="small" sx={inputSx}
                                required autoComplete="off"
                                value={configRadian.imapPort || ''}
                                onChange={e => setConfigRadian({ ...configRadian, imapPort: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="Buzón compartido" fullWidth size="small" sx={inputSx}
                                autoComplete="off"
                                value={configRadian.buzonCompartido || ''}
                                onChange={e => setConfigRadian({ ...configRadian, buzonCompartido: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <FormControlLabel
                                control={<Checkbox size="small" checked={configRadian.ssl_aplica || false} onChange={e => setConfigRadian({ ...configRadian, ssl_aplica: e.target.checked })} />}
                                label={<Typography fontSize="0.78rem">SSL</Typography>} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button variant="contained" size="small" onClick={probarConexion}
                                sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem' }}>
                                Probar conexión
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 2, py: 1 }}>
                    <Button variant="contained" size="small" color="success" onClick={crearNuevaConfigRadian} sx={{ fontSize: '0.78rem' }}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* MODAL: NUEVA NOTA */}
            <Dialog open={notaCompanyCrud.ModalVisible}
                onClose={() => setNotaCompanyCrud({ ...notaCompanyCrud, ModalVisible: false })}
                maxWidth="lg" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">Nueva Nota</Typography>
                    <IconButton size="small" onClick={() => setNotaCompanyCrud({ ...notaCompanyCrud, ModalVisible: false })} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
                        <Grid item xs={12} md={3}>
                            <TextField label="Categoría" select fullWidth size="small" sx={inputSx}
                                value={notaCompanyCrud.Categoria}
                                onChange={e => setNotaCompanyCrud({ ...notaCompanyCrud, Categoria: e.target.value })}>
                                <MenuItem value="" disabled sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                <MenuItem value="SAC" sx={{ fontSize: '0.82rem' }}>SAC</MenuItem>
                                <MenuItem value="COMERCIAL" sx={{ fontSize: '0.82rem' }}>Comercial</MenuItem>
                                <MenuItem value="PQR" sx={{ fontSize: '0.82rem' }}>PQR</MenuItem>
                                <MenuItem value="ADMIN" sx={{ fontSize: '0.82rem' }}>Administración</MenuItem>
                                <MenuItem value="CARTERA" sx={{ fontSize: '0.82rem' }}>Cartera</MenuItem>
                                <MenuItem value="OTRO" sx={{ fontSize: '0.82rem' }}>Otro</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <TextField label="Nota" fullWidth size="small" sx={inputSx}
                                multiline rows={3}
                                value={notaCompanyCrud.Nota}
                                onChange={e => setNotaCompanyCrud({ ...notaCompanyCrud, Nota: e.target.value })} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ px: 2, py: 1 }}>
                    <Button variant="contained" color="error" size="small"
                        onClick={() => setNotaCompanyCrud({ ...notaCompanyCrud, ModalVisible: false })} sx={{ fontSize: '0.78rem' }}>
                        Cerrar
                    </Button>
                    <Button variant="contained" color="success" size="small" onClick={notasUpdate} sx={{ fontSize: '0.78rem' }}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* MODAL: ROL */}
            <Dialog open={rolCompanyCrud.ModalVisible}
                onClose={() => setRolCompanyCrud({ ...rolCompanyCrud, ModalVisible: false })}
                maxWidth="lg" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">{rolCompanyCrud.Titulo}</Typography>
                    <IconButton size="small" onClick={() => setRolCompanyCrud({ ...rolCompanyCrud, ModalVisible: false })} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Grid container spacing={1.5} alignItems="center" sx={{ mt: 0.5, mb: 2 }}>
                        <Grid item xs={12} md={9}>
                            <TextField label="Descripción" fullWidth size="small" sx={inputSx}
                                autoComplete="off"
                                value={rolCompanyCrud.Descripcion}
                                onChange={e => setRolCompanyCrud({ ...rolCompanyCrud, Descripcion: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <FormControlLabel
                                control={<Checkbox size="small" defaultChecked={true} onChange={e => setRolCompanyCrud({ ...rolCompanyCrud, Activo: e.target.checked })} />}
                                label={<Typography fontSize="0.78rem">Activo</Typography>} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Button variant="contained" color="success" size="small" onClick={rolSave} sx={{ fontSize: '0.78rem' }}>Guardar</Button>
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <HeaderCell>Título</HeaderCell>
                                    <HeaderCell>Descripción</HeaderCell>
                                    <HeaderCell align="center">Activo</HeaderCell>
                                    <HeaderCell align="center"></HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rollPermiso.map((item, index) => (
                                    <StyledRow key={item.rollpermisoid} index={index}>
                                        <BodyCell>{item.titulo}</BodyCell>
                                        <BodyCell>{item.descripcion}</BodyCell>
                                        <BodyCell align="center">
                                            <Checkbox size="small" checked={item.activo}
                                                onChange={e => setRollPermiso(rollPermiso.map(p => p.rollpermisoid === item.rollpermisoid ? { ...p, activo: e.target.checked } : p))} />
                                        </BodyCell>
                                        <BodyCell align="center">
                                            {item.cantidadPermisos > 0 && (
                                                <Tooltip title="Ver permisos hijos">
                                                    <IconButton size="small" sx={{ color: '#1976d2' }} onClick={() => verPermisos(item.permisoid, item.rollid)}>
                                                        <FaDownLong size={14} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                        <Button variant="contained" color="success" size="small" onClick={rolSave} sx={{ fontSize: '0.78rem' }}>Guardar</Button>
                        <Button variant="contained" color="warning" size="small" onClick={regresarMenuRoles} sx={{ fontSize: '0.78rem' }}>Cancelar</Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* MODAL: EDITAR USUARIO */}
            <Dialog open={usuarioNuevo.ModalVisible || false}
                onClose={() => { setUsuarioNuevo({ ModalVisible: false, Contrasena: '', Correo: '', Nuevo: false, Rollid: '', Usuarioid: '' }); setRollPermiso([]); }}
                maxWidth="lg" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#224B6A', color: '#fff', py: 1.5, px: 2 }}>
                    <Typography fontWeight={700} fontSize="0.95rem">Editar usuario</Typography>
                    <IconButton size="small" onClick={() => { setUsuarioNuevo({ ModalVisible: false, Contrasena: '', Correo: '', Nuevo: false, Rollid: '', Usuarioid: '' }); setRollPermiso([]); }} sx={{ color: '#fff' }}>
                        <MdClose size={18} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Grid container spacing={1.5} alignItems="center" sx={{ mt: 0.5, mb: 2 }}>
                        <Grid item xs={12} md={4}>
                            <TextField label="Usuario" type="email" fullWidth size="small" sx={inputSx}
                                autoComplete="off"
                                value={usuarioNuevo.Usuario || ''}
                                onChange={e => setUsuarioNuevo({ ...usuarioNuevo, Usuario: e.target.value })} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <FormControlLabel
                                control={<Checkbox size="small" checked={usuarioNuevo.Activo || false} onChange={e => setUsuarioNuevo({ ...usuarioNuevo, Activo: e.target.checked })} />}
                                label={<Typography fontSize="0.78rem">Activo</Typography>} />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Button variant="contained" color="success" size="small" onClick={usuarioModifica} sx={{ fontSize: '0.78rem' }}>Guardar</Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
                        <Grid item xs={12} md={4}>
                            <TextField label="Roles" select fullWidth size="small" sx={inputSx}
                                value={usuarioNuevo.Rollid || ''}
                                onChange={e => setUsuarioNuevo({ ...usuarioNuevo, Rollid: e.target.value })}>
                                <MenuItem value="" sx={{ fontSize: '0.82rem' }}>Seleccione</MenuItem>
                                {rollAsignaUsuario.map((item, key) =>
                                    <MenuItem key={key} value={item.rollid} sx={{ fontSize: '0.82rem' }}>{item.descripcion}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs="auto">
                            <Tooltip title="Agregar rol">
                                <IconButton size="small" sx={{ color: '#1976d2', border: '1px solid currentColor' }} onClick={agregarRolUsuario}>
                                    <FaPlus size={14} />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <HeaderCell align="center">Acciones</HeaderCell>
                                    <HeaderCell>Rol</HeaderCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rollPermiso.map((item, index) => (
                                    <StyledRow key={item.rollid} index={index}>
                                        <BodyCell align="center">
                                            <Tooltip title="Eliminar rol">
                                                <IconButton size="small" color="error" onClick={() => eliminarPermiso(item.rollid)}>
                                                    <FaTrash size={14} />
                                                </IconButton>
                                            </Tooltip>
                                        </BodyCell>
                                        <BodyCell>{item.descripcion}</BodyCell>
                                    </StyledRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>

        </Box>
    );


}


export default EmpresaConfig;
